{
  "accounts": {
    "title": "Gerenciar Contas",
    "subtitle": "Gerencie todas as contas SSH e V2Ray",
    "createTest": "Criar Teste",
    "createAccount": "Criar Conta",
    "createTestShort": "Teste",
    "createAccountShort": "Nova conta",
    "deleteSelectedShort": "Excluir",
    "selectAll": "Selecionar Todas",
    "deleteSelected": "Deletar Selecionadas",
    "totalAccounts": "Total de Contas",
    "activeAccounts": "Contas Ativas",
    "expiredAccounts": "Contas Expiradas",
    "testAccounts": "Contas Teste",
    "searchPlaceholder": "Buscar por usuário ou UUID...",
    "allTypes": "Todos os tipos",
    "onlySSH": "Apenas SSH",
    "onlyV2Ray": "Apenas V2Ray",
    "sshAndV2Ray": "SSH + V2Ray",
    "allStatus": "Todos os status",
    "active": "Ativo",
    "inactive": "Inativo",
    "expired": "Expirado",
    "test": "Teste",
    "allCreatorTypes": "Todos os tipos",
    "admins": "Admins",
    "resellersFilter": "Revendedores",
    "allOnline": "Todos",
    "onlyOnline": "Apenas Online",
    "onlyOffline": "Apenas Offline",
    "allExpiration": "Todas as validades",
    "expiringWithinDays": "Vence em {days} dias",
    "expirationSortDefault": "Ordenação padrão",
    "expirationSortAsc": "Vencimento: mais próximo",
    "expirationSortDesc": "Vencimento: mais distante",
    "specificCreator": "Criador específico",
    "searchCreator": "Buscar criador...",
    "noCreatorsFound": "Nenhum criador encontrado",
    "allCreators": "Todos os criadores",
    "roleSuperAdmin": "Super Admin",
    "roleAdmin": "Admin",
    "roleReseller": "Revendedor",
    "accounts_count": "contas",
    "username": "Usuário",
    "category": "Categoria",
    "type": "Tipo",
    "connections": "Conexões",
    "expiration": "Expiração",
    "status": "Status",
    "actions": "Ações",
    "noAccountsFound": "Nenhuma conta encontrada",
    "expires": "Expira",
    "expiresIn": "Expira em {time}",
    "expiresTomorrow": "Expira amanhã",
    "expiresInDays": "{days}d restantes",
    "expiresInHours": "{hours}h restantes",
    "ssh": "SSH",
    "v2ray": "V2Ray",
    "combo": "SSH + V2Ray",
    "enable": "Ativar",
    "disable": "Desativar",
    "edit": "Editar",
    "renew": "Renovar",
    "clearDevices": "Limpar Dispositivos",
    "delete": "Excluir",
    "deleteConfirm": {
      "titleOne": "Deletar conta?",
      "titleMany": "Deletar {count} conta(s)?",
      "warning": "ATENÇÃO! Esta ação é IRREVERSÍVEL!",
      "questionOne": "Deseja realmente DELETAR a conta \"{username}\"?",
      "questionMany": "Deseja realmente DELETAR {count} conta(s)?",
      "moreCount": " e mais {count}",
      "bulletDbOne": "Será removida do banco de dados",
      "bulletDbMany": "Serão removidas do banco de dados",
      "bulletServersOne": "Será deletada de todos os servidores",
      "bulletServersMany": "Serão deletadas de todos os servidores",
      "bulletDevices": "Todos os dispositivos serão limpos",
      "finalWarning": "Esta ação NÃO pode ser desfeita!"
    },
    "bulkDeleteModal": {
      "title": "Excluir {count} conta(s)?",
      "keepOpenHint": "A exclusão continua em segundo plano. Aguarde até concluir."
    },
    "createModal": {
      "title": "Criar Nova Conta",
      "manual": "Manual",
      "byPlan": "Por Plano",
      "selectPlan": "Selecione um Plano",
      "choosePlan": "Escolha um plano",
      "days": "dias",
      "selectCategory": "Selecione uma categoria",
      "servers": "servidor",
      "serversPlural": "servidores",
      "planDetails": "Detalhes do Plano",
      "planType": "Tipo",
      "validity": "Validade",
      "connectionLimit": "Limite de Conexões",
      "usernameLabel": "Usuário",
      "usernamePlaceholder": "Nome do usuário",
      "passwordLabel": "Senha",
      "passwordHelp": "Mínimo 4 caracteres",
      "passwordPlaceholder": "Senha do usuário",
      "generateRandom": "Gerar credenciais aleatórias",
      "categoryLabel": "Categoria",
      "accountType": "Tipo de Conta",
      "expirationDays": "Dias de Validade",
      "daysPlaceholder": "Ex: 30",
      "createButton": "Criar Conta",
      "creating": "Criando...",
      "summary": "Resumo:",
      "summaryType": "Tipo:",
      "summaryUsername": "Usuário:",
      "summaryValidity": "Validade:",
      "summaryExpires": "Expira em:",
      "summaryCategory": "Categoria:",
      "summaryServers": "Será criado em {count} servidor(es)",
      "usernamePlaceholderManual": "Ex: usuario123",
      "passwordPlaceholderManual": "Ex: senha123",
      "sshOnly": "Apenas SSH",
      "v2rayOnly": "Apenas V2Ray",
      "sshV2ray": "SSH + V2Ray",
      "uuidAutoGenerate": "UUID: Será gerado automaticamente pelo sistema",
      "autoCredentialsInfo": "Credenciais Automáticas: usuário e senha serão gerados automaticamente",
      "selectCategoryPlaceholder": "Selecione uma categoria",
      "selectCategoryError": "Selecione uma categoria",
      "resellerCredits": "Créditos disponíveis",
      "resellerSlots": "Slots disponíveis",
      "resellerSlotsUsed": "{used} slot(s) em uso",
      "emailLabel": "Email",
      "emailPlaceholder": "cliente{'@'}email.com",
      "whatsappLabel": "WhatsApp",
      "whatsappPlaceholder": "+5511999999999",
      "telegramLabel": "Telegram",
      "telegramPlaceholder": "{'@'}usuario ou ID",
      "categoryInheritedHint": "Categoria vinculada ao revendedor (herdada automaticamente)",
      "unlimited": "Ilimitado",
      "generateUsername": "Gerar username",
      "generatePassword": "Gerar senha",
      "validityDaysRange": "Mínimo: {min} dias. Máximo: 3650 dias (10 anos)",
      "buttonTooltips": {
        "saving": "Salvando...",
        "selectPlan": "Selecione um plano",
        "selectCategory": "Selecione uma categoria",
        "insufficientCredits": "Créditos insuficientes. Necessário: {needed}, Disponível: {available}"
      }
    },
    "testModal": {
      "title": "Criar Conta de Teste",
      "categoryLabel": "Categoria",
      "categoryInherited": "Categoria herdada do seu revendedor",
      "serversInCategory": "{count} servidor(es) na categoria selecionada",
      "usernameLabel": "Usuário",
      "usernameHelp": "3-32 caracteres, apenas letras e números",
      "passwordLabel": "Senha",
      "passwordHelp": "Mínimo 4 caracteres",
      "durationLabel": "Duração (horas)",
      "durationPlaceholder": "Ex: 2",
      "maxDuration": "Máximo: {max} horas",
      "includeV2ray": "Incluir V2Ray no teste",
      "testSummary": "Resumo do Teste:",
      "summaryType": "Tipo",
      "summaryValidity": "Validade",
      "summaryCategory": "Categoria",
      "summaryServers": "Será criado em {count} servidor(es)",
      "hours": "horas",
      "createButton": "Criar Teste",
      "creating": "Criando...",
      "hour": "hora",
      "usernamePlaceholder": "Ex: teste123",
      "passwordPlaceholder": "Ex: senha123",
      "generateUsername": "Gerar username aleatório",
      "generatePassword": "Gerar senha aleatória"
    },
    "editAccount": "Editar Conta",
    "connectionLimit": "Limite",
    "statusActive": "Ativo",
    "statusInactive": "Inativo",
    "createdBy": "Criado por",
    "currentPassword": "Senha Atual",
    "naV2ray": "N/A (V2Ray)",
    "actionTooltips": {
      "enable": "Ativar",
      "disable": "Desativar",
      "renewExpired": "Renovar para reativar",
      "renew": "Renovar",
      "copyCredentials": "Copiar credenciais",
      "edit": "Editar",
      "clearDevices": "Limpar Dispositivos",
      "delete": "Deletar"
    },
    "toggleConfirm": {
      "enableTitle": "Ativar conta?",
      "disableTitle": "Desativar conta?",
      "enableMessage": "Deseja ativar a conta \"{username}\"?",
      "disableMessage": "Deseja desativar a conta \"{username}\"?"
    },
    "expiryLabels": {
      "expired": "Expirado",
      "expiresToday": "Expira hoje",
      "expiresTomorrow": "Expira amanhã",
      "expiresInDays": "Expira em {days} dias",
      "expiresInHours": "Expira em {hours}h",
      "minutesRemaining": "{minutes} minuto(s) restante(s)",
      "hoursRemaining": "{hours} hora(s) restante(s)",
      "daysRemaining": "{days} dias restantes"
    },
    "clearDevicesConfirm": {
      "title": "Limpar Dispositivos?",
      "message": "Limpar todos os dispositivos registrados para \"{username}\"?\n\nIsso permitirá que o usuário registre novos dispositivos."
    },
    "editModal": {
      "accountInfo": "Informações da Conta",
      "copyUsername": "Copiar usuário",
      "togglePassword": "Mostrar/ocultar senha",
      "copyPassword": "Copiar senha",
      "copyUuid": "Copiar UUID",
      "uuidNotGenerated": "Não gerado",
      "resellerCreditTitle": "Modo Revendedor Crédito",
      "resellerCreditHint": "Você pode editar a senha e o WhatsApp. Outros campos são somente leitura.",
      "editFields": "Editar Campos",
      "categoryMigrationHint": "Ao trocar de categoria, a conta será migrada para os servidores da nova categoria",
      "newPassword": "Nova Senha",
      "passwordKeepPlaceholder": "Deixe vazio para manter a senha atual",
      "passwordKeepHint": "Deixe em branco para não alterar. Mínimo 4 caracteres se alterar.",
      "expirationDate": "Data de Expiração",
      "saveChanges": "Salvar Alterações",
      "expiryPastWarning": "Data no passado — conta ficará expirada",
      "expiryInDays": "Expira em {days} dia(s)"
    },
    "renewModal": {
      "title": "Renovar Conta",
      "accountLabel": "Conta:",
      "typeLabel": "Tipo:",
      "expiresLabel": "Expira em:",
      "addDays": "Adicionar Dias",
      "addDaysHint": "Adicionar dias à data de expiração atual",
      "addMonths": "Adicionar Validade (meses)",
      "monthOption": "{months} mês(es) ({days} dias) - {credits} crédito(s)",
      "addDaysPreview": "Adicionar {days} dias à validade atual",
      "creditsAvailable": "Créditos disponíveis:",
      "creditsInsufficientShort": "Créditos insuficientes!",
      "newExpiryLabel": "Nova data de expiração:",
      "daysAdded": "(+{days} dia(s))",
      "creditsSufficient": "Créditos Suficientes",
      "creditsInsufficient": "Créditos Insuficientes!",
      "creditsAvailableLabel": "Créditos Disponíveis:",
      "creditsNeededLabel": "Créditos Necessários:",
      "balanceAfterRenewal": "Saldo Após Renovação:",
      "creditsMissing": "Faltam {count} créditos!",
      "syncWarning": "Atenção: A renovação será sincronizada automaticamente com todos os servidores da categoria.",
      "renewing": "Renovando...",
      "submit": "Renovar Conta",
      "insufficientCredits": "Créditos insuficientes! Você tem {available}, precisa de {needed}",
      "insufficientCreditsTooltip": "Créditos insuficientes"
    },
    "resultModal": {
      "title": "Conta criada com sucesso",
      "serversCount": "{count} servidor(es) · {category}",
      "provisioningPendingTitle": "Sincronização em andamento.",
      "provisioningPendingBody": " A conta já foi criada no painel. Os servidores serão atualizados em segundo plano — se algum estiver offline, o administrador será notificado.",
      "validityDays": "{days} dias",
      "validityLabel": "Validade",
      "expiresAtLabel": "Expira em",
      "categoryLabel": "Categoria",
      "serversLabel": "Servidores",
      "planLabel": "Plano",
      "connectionLimitLabel": "Limite de conexões",
      "connectionLimitValue": "{limit} dispositivo(s)",
      "createdModePlan": "Por plano",
      "createdModeManual": "Manual",
      "copyHint": "Copie os dados abaixo ou envie a mensagem pronta pelo WhatsApp/Telegram."
    },
    "testResultModal": {
      "title": "Conta teste criada",
      "badge": "Conta teste",
      "validityHours": "{hours} hora(s)"
    },
    "deletePlanModal": {
      "title": "Deletar Plano",
      "question": "Tem certeza que deseja deletar o plano",
      "cannotUndo": "Esta ação não pode ser desfeita."
    }
  },
  "servers": {
    "title": "Servidores",
    "subtitle": "Gerencie todos os servidores SSH e V2Ray",
    "addServer": "Adicionar Servidor",
    "addServerShort": "Servidor",
    "totalServers": "Total de Servidores",
    "activeServers": "Servidores Ativos",
    "inactiveServers": "Servidores Inativos",
    "installedApis": "APIs Instaladas",
    "cpuCores": "{count} núcleos",
    "name": "Nome",
    "host": "Host",
    "category": "Categoria",
    "type": "Tipo",
    "status": "Status",
    "actions": "Ações",
    "noServersFound": "Nenhum servidor encontrado",
    "syncLabel": "Sincronizar",
    "uninstall": "Desinstalar",
    "reinstallApi": "Reinstalar API",
    "edit": "Editar",
    "apiInstalled": "API Instalada",
    "apiError": "API com Erro",
    "apiNotInstalled": "API Não Instalada",
    "sync": {
      "syncing": "Sincronizando...",
      "startedTitle": "Sincronização iniciada",
      "startedMessage": "A sincronização de «{name}» foi iniciada. Será notificado quando terminar.",
      "completedTitle": "Sincronização concluída",
      "completedWithErrorsTitle": "Sincronização com erros",
      "completedPartialTitle": "Sincronização com ressalvas",
      "errorTitle": "Erro na sincronização",
      "errorGeneric": "Não foi possível sincronizar o servidor",
      "startFailed": "Não foi possível iniciar a sincronização",
      "startUncertain": "O pedido demorou, mas a sincronização pode ter sido iniciada. Aguarde a notificação no sininho.",
      "startFailedTitle": "Erro na sincronização",
      "slowTitle": "Sincronização demorada",
      "slowMessage": "A sincronização ainda está em curso. Verifique as notificações em breve.",
      "notificationBody": "Servidor «{server}»: {summary}",
      "notificationFailed": "Servidor «{server}»: {error}",
      "bellCompleted": "Sincronização concluída",
      "bellPartial": "Sincronização concluída com ressalvas",
      "bellWithErrors": "Sincronização com erros",
      "bellError": "Erro na sincronização",
      "resultEligible": "📤 {count} enviada(s) à API",
      "resultAccountsProcessed": "📋 {count} conta(s) processada(s)",
      "resultSshSent": "🔐 {count} SSH à API",
      "resultV2raySent": "📡 {count} V2Ray à API",
      "resultNoneEligible": "Nenhuma conta activa elegível para sincronizar",
      "resultSynced": "✅ {count} OK (todos os protocolos)",
      "resultPartial": "⚠️ {count} parcial (SSH ou V2Ray)",
      "resultPartialOk": "✓ {count} OK em parte dos protocolos",
      "resultApiRejected": "❌ {count} rejeitada(s) pela API",
      "resultSkippedHeader": "Ignoradas: {list}",
      "resultCategoryTotal": "📊 {count} na categoria",
      "resultExpired": "⏰ {count} expirada(s)",
      "resultInactive": "🔒 {count} desativada(s)",
      "resultInvalid": "⚠️ {count} sem credencial válida",
      "resultReseller": "🚫 {count} revendedor inativo/expirado",
      "resultFailed": "❌ {count} erro(s)",
      "resultTotal": "📊 Total: {count}",
      "summaryEligible": "{count} enviada(s) à API",
      "summaryAccountsProcessed": "{count} conta(s) processada(s)",
      "summarySshSent": "{count} SSH à API",
      "summaryV2raySent": "{count} V2Ray à API",
      "summaryOutcome": "resultado: {list}",
      "summaryApiOkTotal": "{count} OK ({ssh} SSH + {v2ray} V2Ray)",
      "summaryApiRejectedTotal": "{count} rejeitado(s) API",
      "resultAccountsSynced": "✅ {count} conta(s) sincronizada(s)",
      "resultAccountsFailed": "❌ {count} conta(s) com falha",
      "summarySynced": "{count} OK",
      "summaryPartial": "{count} parcial",
      "summaryPartialOk": "{count} OK parcial",
      "summaryApiRejected": "{count} rejeitada(s) API",
      "summarySkipped": "ignoradas: {list}",
      "summaryCategoryTotal": "{count} na categoria",
      "summaryExpired": "{count} expirada(s) ignorada(s)",
      "summaryInactive": "{count} inativa(s) ignorada(s)",
      "summaryInvalid": "{count} sem credencial válida",
      "summaryReseller": "{count} revendedor inativo/expirado",
      "summaryFailed": "{count} falha(s) total na API",
      "summaryTotal": "total {count}"
    },
    "installProgress": {
      "modalTitle": "Instalando API no Servidor",
      "progressLabel": "Progresso",
      "cancel": "Cancelar",
      "close": "Fechar",
      "connectingSsh": "Conectando ao servidor SSH...",
      "logStarting": "Iniciando instalação da API...",
      "logConnecting": "Conectando via SSH...",
      "installSuccess": "API instalada com sucesso!",
      "adoptedSuccess": "API existente vinculada e binário atualizado!",
      "failedToast": "Instalação da API falhou. Verifique os logs.",
      "sshAuthFailed": "Falha na autenticação SSH. Verifique usuário e senha do servidor.",
      "sshConnectionFailed": "Não foi possível conectar ao servidor. Verifique host, porta SSH e firewall.",
      "completedMessage": "Instalação concluída com sucesso!",
      "apiRespondingOnPort": "API respondendo na porta {port}",
      "waiting_start": "Aguardando início...",
      "checking_existing": "Verificando instalação existente...",
      "existing_detected": "API existente detectada — preservando chave, porta {port} e atualizando apenas o binário",
      "services_stopped": "Serviço(s) anterior(es) parado(s): {names}",
      "detecting_architecture": "Detectando arquitetura...",
      "binary_selected": "Binário: {binaryName} (GitHub Releases)",
      "creating_directories": "Criando diretórios...",
      "downloading_binary": "Baixando binário do GitHub (painel)...",
      "uploading_binary": "Enviando binário para o servidor via SFTP...",
      "binary_downloaded": "Binário implantado ({sizeMb} MB)",
      "binary_path_resolved": "Caminho do binário no servidor: {path}",
      "binary_deployed": "Binário substituído em {path} ({sizeMb} MB)",
      "binary_upload_failed": "Falha ao enviar binário para o servidor via SFTP.",
      "binary_upload_size_mismatch": "Binário enviado incompleto (local: {local} bytes, remoto: {remote} bytes).",
      "keeping_systemd": "Mantendo unit systemd existente (chave e porta preservadas)",
      "configuring_systemd": "Configurando systemd...",
      "reloading_systemd": "Recarregando systemd...",
      "enabling_service": "Habilitando serviço...",
      "starting_service": "Iniciando serviço...",
      "checking_status": "Verificando status...",
      "service_active": "Serviço VeltrixPanel ativo!",
      "testing_api": "Testando API...",
      "api_responding": "API respondendo (HTTP 200)",
      "completed": "Instalação concluída!",
      "existing_service_detected": "Instalação existente detectada (VeltrixPanel.service)",
      "existing_key_reused": "Chave existente será reutilizada para manter compatibilidade com outros painéis",
      "existing_port_reused": "Porta existente será reutilizada: {port}",
      "existing_port_not_found": "Instalação existente detectada, mas não foi possível ler a porta do serviço systemd",
      "services_stopped_ok": "Serviço(s) anterior(es) parado(s)",
      "arch_detected": "Arquitetura detectada: {arch}",
      "systemd_preserved": "Configuração systemd mantida — apenas binário atualizado",
      "unsupported_architecture": "Arquitetura não suportada: {arch}",
      "binary_download_failed": "Falha ao baixar binário do GitHub (tamanho: {fileSize} bytes). Verifique a conexão do painel com a internet.",
      "service_not_started": "Serviço não iniciou (status: {status})",
      "exception": "Erro: {message}"
    },
    "noServers": "Nenhum servidor",
    "noServersHint": "Adicione seu primeiro servidor para começar",
    "loadingMetrics": "Carregando métricas...",
    "online": "Online",
    "offline": "Offline",
    "viewOnlineUsers": "Ver onlines",
    "onlineUsersModal": {
      "title": "Usuários online — {name}",
      "subtitle": "Lista em tempo real via API Sentinel (/users/online)",
      "refresh": "Atualizar",
      "loading": "Carregando usuários online...",
      "loadError": "Não foi possível carregar os usuários online deste servidor.",
      "empty": "Nenhum usuário online no momento.",
      "total": "Total: {count}",
      "sshSection": "SSH",
      "v2raySection": "V2Ray",
      "protoSection": "DT-Proto",
      "username": "Usuário",
      "email": "E-mail",
      "uuid": "UUID",
      "lastConnection": "Última conexão",
      "id": "ID"
    },
    "installApi": "Instalar API",
    "installRestricted": "Instalação restrita a Super Admin",
    "installRestrictedShort": "Restrito",
    "creating": "Criando...",
    "editServerTitle": "Editar Servidor",
    "editServerSubtitle": "Atualize as informações do servidor {name}",
    "newSshPassword": "Nova Senha SSH (deixe em branco para manter a atual)",
    "newSshPasswordPlaceholder": "Digite a nova senha SSH (opcional)",
    "defaultCategory": "Padrão",
    "noCategoriesWarning": "Nenhuma categoria cadastrada. Usando categoria padrão.",
    "addServerButton": "Adicionar Servidor",
    "ssh2ExtensionError": "Extensão SSH2 não está instalada.\n\n{instructions}\n\n{note}",
    "deleteModal": {
      "title": "Excluir Servidor",
      "confirm": "Tem certeza que deseja excluir o servidor {name}?",
      "irreversible": "⚠️ Esta ação não pode ser desfeita!",
      "uninstallApiLabel": "Desinstalar API do servidor antes de excluir",
      "uninstallApiHelp": "Recomendado: Remove o serviço API do servidor remoto. Desmarque apenas se não tiver mais acesso SSH ao servidor.",
      "confirmButton": "Sim, Excluir Servidor"
    },
    "installModal": {
      "title": "Instalar API {panelName}",
      "subtitle": "Configure a instalação da API no servidor {name}",
      "apiPortLabel": "Porta da API",
      "autoKeyTitle": "API Key Automática",
      "autoKeyHelp": "A API Key será gerada automaticamente durante a instalação e configurada no servidor. Você poderá visualizá-la após a conclusão.",
      "installing": "Instalando..."
    },
    "apiUninstallConfirm": "Tem certeza que deseja desinstalar a API do servidor \"{name}\"?\n\nIsso parará o serviço {panelName} API no servidor remoto."
  },
  "categories": {
    "title": "Categorias",
    "subtitle": "Organize seus servidores em categorias",
    "addCategory": "Nova Categoria",
    "addCategoryShort": "Categoria",
    "name": "Nome",
    "servers": "Servidores",
    "accounts": "Contas",
    "actions": "Ações",
    "noCategoriesFound": "Nenhuma categoria encontrada",
    "emptyHint": "Crie sua primeira categoria para organizar servidores e usuários",
    "defaultBadge": "Padrão",
    "users": "Usuários",
    "setAsDefault": "Definir como Padrão",
    "migrate": "Migrar",
    "migrateFrom": "Migrar de: {name}",
    "migrateType": "Tipo",
    "migrateEntityUsers": "Usuários",
    "migrateEntityServers": "Servidores",
    "migrateEntityResellers": "Revendedores",
    "migrateTargetCategory": "Categoria de Destino",
    "migrateAttention": "Atenção!",
    "migrating": "Migrando...",
    "confirmMigration": "Confirmar Migração",
    "cannotDeleteDefault": "Não é possível deletar a categoria padrão",
    "deleteConfirm": {
      "title": "Deletar categoria?",
      "question": "Tem certeza que deseja deletar a categoria \"{name}\"?",
      "finalWarning": "Esta ação não pode ser desfeita."
    },
    "migrateWarnings": {
      "users": "As contas desta categoria serão movidas. Contas vinculadas a revendedores também levarão o revendedor, sub-revendedores, contas da hierarquia e a migração nos servidores.",
      "resellers": "Os revendedores desta categoria serão movidos junto com sub-revendedores, contas da hierarquia e a migração nos servidores.",
      "servers": "Todos os servidores desta categoria serão movidos para a categoria selecionada."
    }
  },
  "checkuser": {
    "title": "CheckUser",
    "subtitle": "Gerenciar CheckUser para DTunnel e Conecta4G",
    "dtunnelUrl": "URL DTunnel",
    "conectaUrl": "URL Conecta4G",
    "devicePolicyCardTitle": "Dispositivos (DTunnel)",
    "devicePolicyCardSubtitle": "Limite por conta e limpeza de registos na mesma área.",
    "deviceLimitTitle": "Limitador por dispositivo",
    "deviceLimitDesc": "Quando ativo, o checkuser regista cada deviceId e devolve count_connections (total de aparelhos). O app DTunnel compara com limit_connections e aplica o limite.",
    "deviceLimitOffHint": "Com o limitador desligado, o checkuser ignora deviceId (não grava) e devolve count_connections = 0. O limite no app fica desactivado do lado do servidor.",
    "cleanupSectionTitle": "Limpeza automática",
    "cleanupSectionSubtitle": "O worker remove registos inactivos conforme o intervalo abaixo.",
    "cleanupTotalTitle": "Limpeza total",
    "cleanupTotalDesc": "Remove todos os dispositivos de todos os utilizadores. Use apenas se souber o impacto.",
    "inactivityLabel": "Tempo de inactividade",
    "inactivityHelp": "Registos sem acesso há mais tempo que isto são elegíveis para remoção (limpeza automática ou manual).",
    "howItWorksTitle": "Como funciona",
    "howItWorksBullet1": "O worker em segundo plano verifica periodicamente.",
    "howItWorksBullet2": "Dispositivos sem acesso no período configurado podem ser removidos.",
    "howItWorksBullet3": "Liberta espaço e permite novos registos.",
    "howItWorksBullet4": "Contas activas em uso normal não são afectadas pelo intervalo escolhido.",
    "statsTotalDevices": "Dispositivos totais",
    "statsUsersWithDevices": "Utilizadores com dispositivos",
    "statsActive24h": "Activos (24 h)",
    "statsUsersAtLimit": "No limite",
    "lastAutoCleanup": "Última limpeza automática",
    "lastAutoCleanupNever": "Ainda não registada",
    "runCleanupNow": "Executar Agora",
    "runCleanupRunning": "A executar…",
    "interval1h": "1 hora",
    "interval2h": "2 horas",
    "interval6h": "6 horas",
    "interval12h": "12 horas",
    "interval24h": "24 horas (1 dia)",
    "interval48h": "48 horas (2 dias)",
    "interval7d": "7 dias (1 semana)",
    "deviceCleanup": "Limpeza de Dispositivos",
    "cleanupInterval": "Intervalo de Limpeza",
    "executeNow": "Executar Agora",
    "clearAll": "Limpar Todos",
    "copyUrl": "Copiar URL",
    "test": "Testar",
    "testing": "Testando...",
    "minutes": "minutos",
    "enabled": "Ativado",
    "disabled": "Desativado",
    "autoCleanup": "Limpeza automática roda em background a cada {minutes} minutos",
    "confirmClearAll": "Limpar TODOS os Dispositivos?",
    "confirmClearAllDesc": "Esta ação irá limpar TODOS os dispositivos de TODOS os utilizadores. Esta operação NÃO pode ser desfeita!"
  },
  "backup": {
    "title": "Gerenciar Backup",
    "subtitle": "Configure backups automáticos via Telegram",
    "telegramBot": "Bot do Telegram",
    "botToken": "Token do Bot",
    "chatId": "Chat ID",
    "backupPassword": "Senha do Backup",
    "interval": "Intervalo",
    "lastBackup": "Último Backup",
    "executeNow": "Fazer Backup Agora",
    "restoreBackup": "Restaurar Backup",
    "automaticBackup": "Backup Automático",
    "restoreTab": "Restaurar Backup",
    "telegramConfig": "Configuração do Telegram",
    "botTokenPlaceholder": "1234567890:ABCdefGHIjklMNOpqrsTUVwxyz",
    "chatIdPlaceholder": "123456789",
    "backupPasswordPlaceholder": "Senha para criptografar o backup",
    "backupInterval": "Intervalo de Backup",
    "selectInterval": "Selecione o intervalo",
    "everyHour": "A cada 1 hora",
    "every6Hours": "A cada 6 horas",
    "every12Hours": "A cada 12 horas",
    "daily": "Diariamente",
    "saveConfig": "Salvar Configuração",
    "uploadBackup": "Enviar Arquivo de Backup",
    "selectFile": "Selecione o arquivo .sql.enc",
    "restoreButton": "Restaurar Database",
    "telegramBackupDesc": "Envie backups criptografados da database para o Telegram",
    "botTokenLabel": "Bot Token",
    "createBotHelp": "Crie um bot com",
    "intervalLabel": "Intervalo de Backup",
    "interval1min": "A cada 1 minuto (TESTE)",
    "interval5min": "A cada 5 minutos",
    "interval15min": "A cada 15 minutos",
    "interval30min": "A cada 30 minutos",
    "interval1hour": "A cada 1 hora",
    "interval6hours": "A cada 6 horas",
    "interval12hours": "A cada 12 horas",
    "intervalDaily": "Diariamente (24h)",
    "interval2days": "A cada 2 dias",
    "intervalWeekly": "Semanalmente (7 dias)",
    "intervalHelp": "Valores em minutos. Worker verifica automaticamente e executa no intervalo configurado.",
    "chatIdHelp": "Use {'@'}userinfobot para obter seu Chat ID",
    "passwordNewPlaceholder": "Digite nova senha ou deixe em branco para manter a atual",
    "passwordInitialPlaceholder": "Configure uma senha de criptografia (mínimo 8 caracteres)",
    "passwordConfiguredStatus": "Senha de backup configurada",
    "passwordNotConfiguredStatus": "Configure uma senha de backup",
    "passwordHelpConfigured": "Deixe em branco para manter a senha atual. Mínimo 8 caracteres se alterar.",
    "passwordHelpRequired": "Senha obrigatória para criptografia do backup. Guarde-a com segurança!",
    "lastAutomaticBackup": "Último Backup Automático",
    "nextBackupIn": "Próximo em ~{minutes} min",
    "howItWorksTitle": "Como funciona:",
    "howItWorksItem1": "Worker em background executa automaticamente",
    "howItWorksItem2": "Database é criptografada com AES-256",
    "howItWorksItem3": "Backup enviado para o Telegram",
    "howItWorksItem4": "Guarde sua senha para restaurar",
    "saveSettings": "Salvar Configurações",
    "manualBackupTitle": "Fazer backup manual agora",
    "manualBackupDisabledTitle": "Configure a senha de backup primeiro",
    "restoreSubtitle": "Restaure um backup criptografado da database",
    "selectFileButton": "Selecionar Arquivo",
    "criticalOperationTitle": "⚠️ ATENÇÃO - OPERAÇÃO CRÍTICA",
    "criticalOperationItem1": "Esta operação APAGARÁ todos os dados atuais",
    "criticalOperationItem2": "Faça um backup atual antes de restaurar",
    "criticalOperationItem3": "Certifique-se de ter o arquivo correto",
    "criticalOperationItem4": "O sistema ficará indisponível durante a restauração",
    "criticalOperationItem5": "Você será desconectado após a restauração",
    "restoreProgressTitle": "Restaurando backup...",
    "restoreProgressWait": "Aguarde. Esta operação pode levar alguns minutos. Não feche esta página.",
    "confirmRestoreCheckbox": "Eu entendo que esta operação irá APAGAR TODOS OS DADOS ATUAIS e substituí-los pelo backup. Confirmo que fiz um backup da database atual e tenho certeza que desejo prosseguir."
  },
  "logs": {
    "title": "Logs do Sistema",
    "subtitle": "Histórico de ações e eventos do painel",
    "level": "Nível",
    "message": "Mensagem",
    "date": "Data/Hora",
    "action": "Ação",
    "user": "Usuário",
    "ip": "IP",
    "clearAll": "Limpar Tudo",
    "clearAllShort": "Limpar",
    "refresh": "Atualizar",
    "totalLogs": "Total de Logs",
    "last24h": "Últimas 24h",
    "errors": "Erros",
    "warnings": "Avisos",
    "info": "Info",
    "filterByLevel": "Filtrar por nível",
    "allLevels": "Todos os níveis",
    "allActions": "Todas as ações",
    "allEntities": "Todas as entidades",
    "dateFrom": "Data inicial",
    "dateTo": "Data final",
    "clickToViewDetails": "Clique para ver detalhes",
    "detailModal": {
      "title": "Detalhes do log",
      "logId": "ID do registro",
      "entity": "Entidade",
      "userAgent": "User-Agent",
      "oldValues": "Valores anteriores",
      "newValues": "Valores novos",
      "rawDescription": "Descrição bruta",
      "loadError": "Erro ao carregar detalhes do log"
    },
    "error": "Erro",
    "warning": "Aviso",
    "searchLogs": "Buscar em logs...",
    "noLogsFound": "Nenhum log encontrado",
    "loading": "Carregando...",
    "recordsTitle": "Registros de log",
    "showingRecords": "Mostrando {shown} de {total} registros",
    "lastNLogs": "Últimos {limit} logs",
    "records50": "50 registros",
    "records100": "100 registros",
    "records200": "200 registros",
    "records500": "500 registros",
    "systemUser": "Sistema",
    "confirmClearTitle": "Limpar todos os logs",
    "confirmClearBody": "Deseja remover TODOS os registros de log? Esta ação não pode ser desfeita.",
    "details": "Detalhes",
    "confirmClearOld": "Limpar logs antigos (>90 dias)?"
  },
  "imageCrop": {
    "title": "Recortar imagem",
    "subtitle": "Ajuste o enquadramento. Saída: {width}×{height}px",
    "confirm": "Usar recorte",
    "processing": "Processando..."
  },
  "profile": {
    "title": "Meu Perfil",
    "subtitle": "Gerencie suas informações pessoais",
    "avatarTitle": "Foto de Perfil",
    "choosePhoto": "Escolher Foto",
    "uploading": "Enviando...",
    "avatarFormatsHint": "Formatos: JPG, PNG • Até {max} MB na seleção • Recorte e compressão automáticos (512×512)",
    "cropAvatarTitle": "Recortar foto de perfil",
    "usernameReadonlyHint": "O usuário não pode ser alterado",
    "emailReadonlyHint": "O email não pode ser alterado",
    "role": "Cargo",
    "notAvailable": "N/D",
    "removeAvatarTitle": "Remover foto de perfil?",
    "changePassword": "Alterar Senha",
    "currentPassword": "Senha Atual",
    "newPassword": "Nova Senha",
    "confirmPassword": "Confirmar Senha",
    "confirmNewPassword": "Confirmar Nova Senha",
    "currentPasswordPlaceholder": "Digite sua senha atual",
    "newPasswordPlaceholder": "Digite a nova senha",
    "confirmPasswordPlaceholder": "Confirme a nova senha",
    "roles": {
      "super_admin": "Super Administrador",
      "admin": "Administrador",
      "reseller": "Revendedor"
    }
  },
  "accountPlans": {
    "title": "Planos de Contas",
    "subtitle": "Gerencie os planos disponíveis para contas",
    "addPlan": "Novo Plano",
    "addPlanShort": "Plano",
    "editPlan": "Editar Plano",
    "name": "Nome do Plano",
    "type": "Tipo",
    "sshOnly": "Apenas SSH",
    "v2rayOnly": "Apenas V2Ray",
    "both": "SSH + V2Ray",
    "validity": "Validade (dias)",
    "validityMonths": "Validade (meses)",
    "connectionLimit": "Limite de Conexões",
    "price": "Preço",
    "actions": "Ações",
    "noPlansFound": "Nenhum plano encontrado",
    "createFirstPlan": "Criar primeiro plano",
    "modalTitle": "Novo Plano de Conta",
    "modalEditTitle": "Editar Plano de Conta",
    "namePlaceholder": "Ex: Plano Premium 30 dias",
    "description": "Descrição",
    "descriptionPlaceholder": "Descrição do plano (opcional)",
    "selectType": "Selecione o tipo",
    "validityPlaceholder": "Ex: 30",
    "connectionLimitPlaceholder": "Ex: 1",
    "connectionLimitMinHelp": "Mínimo: 1 conexão simultânea",
    "planActive": "Plano ativo",
    "pricePlaceholder": "Ex: 15.00",
    "createButton": "Criar Plano",
    "saveButton": "Salvar Alterações"
  },
  "resellerPlans": {
    "title": "Planos de Revenda",
    "subtitle": "Gerencie os planos para revendedores",
    "addPlan": "Novo Plano",
    "addPlanShort": "Plano",
    "editPlan": "Editar Plano",
    "name": "Nome do Plano",
    "credit": "Crédito",
    "subscriptionLimit": "Limite de Assinaturas",
    "connectionLimit": "Limite de Conexões",
    "validity": "Validade (dias)",
    "price": "Preço",
    "actions": "Ações",
    "noPlansFound": "Nenhum plano encontrado",
    "modalTitle": "Novo Plano de Revenda",
    "modalEditTitle": "Editar Plano de Revenda",
    "namePlaceholder": "Ex: Plano Revendedor Premium",
    "description": "Descrição",
    "descriptionPlaceholder": "Descrição do plano (opcional)",
    "creditAmount": "Quantidade de Crédito",
    "creditPlaceholder": "Ex: 100",
    "subscriptionLimitPlaceholder": "Ex: 50",
    "connectionLimitPlaceholder": "Ex: 1",
    "validityPlaceholder": "Ex: 30",
    "durationMonths": "Duração (meses)",
    "pricePlaceholder": "Ex: 50.00",
    "createButton": "Criar Plano",
    "saveButton": "Salvar Alterações",
    "total": "Total",
    "creditPlans": "Crédito",
    "subscriptionPlans": "Assinatura",
    "credits": "créditos",
    "typeCredit": "Crédito",
    "typeSubscription": "Assinatura",
    "creditType": "Crédito",
    "subscriptionType": "Assinatura",
    "creditTypeDesc": "Quantidade fixa",
    "subscriptionTypeDesc": "Limite de assinaturas",
    "blockedCredit": "🔒 Bloqueado (você é Assinatura)",
    "blockedSubscribe": "🔒 Bloqueado (você é Crédito)",
    "loadingInfo": "⏳ Carregando informações...",
    "creditResellerInfo": "ℹ️ Revendedor tipo CRÉDITO só pode criar planos de CRÉDITO",
    "subscribeResellerInfo": "ℹ️ Revendedor tipo ASSINATURA só pode criar planos de ASSINATURA",
    "noPlansMessage": "Nenhum plano cadastrado. Crie seu primeiro plano!",
    "planActive": "Plano ativo",
    "durationDays": "Duração (dias)",
    "plan": "Plano",
    "type": "Tipo",
    "details": "Detalhes",
    "loading": "Carregando...",
    "noPlansFull": "Nenhum plano cadastrado. Crie seu primeiro plano!",
    "daysLogins": "dias / logins",
    "active": "Ativo",
    "inactive": "Inativo",
    "deletePlanModal": {
      "title": "Deletar Plano",
      "question": "Tem certeza que deseja deletar o plano",
      "cannotUndo": "Esta ação não pode ser desfeita."
    }
  },
  "serverModal": {
    "title": "Adicionar Servidor",
    "editTitle": "Editar Servidor",
    "subtitle": "Gerencie todos os servidores SSH e V2Ray",
    "name": "Nome",
    "namePlaceholder": "Ex: Servidor Principal",
    "host": "Host/IP",
    "hostPlaceholder": "Ex: 192.168.1.1",
    "hostHelp": "Suporta IPv4, IPv6 e hostnames",
    "sshPort": "Porta SSH",
    "sshPortPlaceholder": "22",
    "sshUser": "Usuário SSH",
    "sshUserPlaceholder": "root",
    "sshPassword": "Senha SSH",
    "sshPasswordPlaceholder": "***",
    "sshPasswordWarning": "A senha será usada para conectar via SSH e instalar a API",
    "category": "Categoria",
    "selectCategory": "Selecione uma categoria",
    "addCategory": "Adicionar categoria",
    "setDefault": "Definir como categoria padrão",
    "defaultHelp": "A categoria padrão será usada quando nenhuma categoria for especificada",
    "apiPort": "Porta da API",
    "apiPortPlaceholder": "8080",
    "apiPortHelp": "Porta onde a API será executada (1024-65535)",
    "status": "Status",
    "active": "Ativo",
    "inactive": "Inativo",
    "cancel": "Cancelar",
    "save": "Salvar",
    "create": "Criar Servidor"
  },
  "categoryModal": {
    "title": "Adicionar Categoria",
    "editTitle": "Editar Categoria",
    "name": "Nome",
    "namePlaceholder": "Ex: Premium",
    "description": "Descrição",
    "descriptionPlaceholder": "Descrição da categoria",
    "cancel": "Cancelar",
    "save": "Salvar",
    "create": "Criar Categoria"
  },
  "salesLink": {
    "title": "Seu Link de Vendas",
    "subtitle": "Compartilhe com seus clientes",
    "accountSalesLabel": "Vendas de Contas SSH/V2Ray",
    "accountSalesHelp": "Clientes podem comprar planos de acesso através deste link",
    "resellerSalesLabel": "Vendas de Planos de Revenda",
    "resellerSalesHelp": "Novos revendedores podem se cadastrar através deste link",
    "renewalLabel": "Renovação de credenciais",
    "renewalHelp": "Clientes podem renovar contas SSH/V2Ray informando usuário ou UUID",
    "recoveryLabel": "Recuperação de credenciais",
    "recoveryHelp": "Clientes podem receber usuário e senha por e-mail (quando habilitado nas configurações)",
    "linkCopied": "Link copiado para área de transferência!",
    "copyError": "Erro ao copiar link",
    "salesDisabled": "Vendas automáticas desabilitadas",
    "salesDisabledHelp": "Ative as vendas automáticas nas configurações para gerar seu link",
    "publicTestLabel": "Testes públicos",
    "publicTestHelp": "Link da página de testes grátis (quando habilitado)."
  },
  "automations": {
    "title": "Automações",
    "subtitle": "Configure automações e integrações",
    "paymentGateways": "Gateways de Pagamento",
    "addGateway": "Adicionar Gateway",
    "editGateway": "Editar Gateway",
    "provider": "Provedor",
    "region": "Região",
    "accessToken": "Token de Acesso",
    "accessTokenEditPlaceholder": "Deixe em branco para manter o token atual",
    "accessTokenEditHint": "Por segurança o token não é exibido. Preencha apenas se quiser substituí-lo.",
    "mpAccessTokenStoredHint": "Access Token já salvo. Preencha só se quiser trocar.",
    "webhookSecretEditPlaceholder": "Deixe em branco para manter o secret atual",
    "webhookSecretStoredHint": "Webhook Secret já salvo. Preencha só se quiser trocar.",
    "status": "Status",
    "actions": "Ações",
    "noGateways": "Nenhum gateway configurado",
    "sales": "Vendas Automáticas",
    "activateSales": "Ativar Vendas",
    "salesUrl": "URL de Vendas",
    "resellerSales": "Vendas de Revenda",
    "activateResellerSales": "Ativar Vendas de Revenda",
    "gateway": "Gateway",
    "selectProvider": "Selecione...",
    "mercadoPago": "Mercado Pago",
    "asaas": "Asaas",
    "efiBank": "EFI Bank (Efí Pay)",
    "paypal": "PayPal",
    "regionCountry": "Região / País",
    "cannotChangeProvider": "Não é possível alterar o provider após criar",
    "cannotChangeRegion": "Não é possível alterar a região após criar",
    "mpCredentials": "Credenciais Mercado Pago",
    "publicKey": "Public Key",
    "publicKeyPlaceholder": "APP_USR-...",
    "mpPublicKeyHint": "Chave pública (Checkout Transparente ou Bricks). Obrigatória para cartão. Não use o Access Token aqui.",
    "testMode": "Modo de Teste",
    "testModeHelp": "Ative para usar credenciais de teste",
    "managePaymentMethods": "Gerenciar Métodos de Pagamento",
    "paymentMethods": "Métodos de Pagamento",
    "enabledMethods": "Métodos Habilitados",
    "selectMethods": "Selecione os métodos que deseja aceitar",
    "managePaymentMethodsDesc": "Gerencie seus métodos de pagamento",
    "messageTemplatesTitle": "Templates de mensagens",
    "messageTemplatesSubtitle": "Personalize as mensagens de conta, revenda, teste e vendas. Campos vazios herdam do revenda/master acima.",
    "messageTemplatesInheritanceHint": "Deixe em branco ou use «Restaurar padrão» para herdar do master. Só salva o que você personalizar.",
    "messageTemplatesSaved": "Templates salvos com sucesso!",
    "noGatewaysConfigured": "Nenhum gateway de pagamento configurado",
    "configureGatewayFirst": "Configure um gateway de pagamento primeiro",
    "salesWarning": "Para ativar vendas e revendas automáticas, adicione pelo menos um gateway de pagamento acima (Mercado Pago, Asaas ou PayPal).",
    "salesSettingsTitle": "Configurações de vendas",
    "salesCategoryLabel": "Categoria para vendas",
    "accountSalesCategoryLabel": "Categoria para vendas de contas",
    "resellerSalesCategoryLabel": "Categoria para vendas de revenda",
    "salesCategoryAdminHelp": "Defina a categoria usada nas vendas automáticas. Essa configuração vale para contas e revendas.",
    "salesCategoryResellerHelp": "A categoria é herdada do seu cadastro de revenda e não pode ser alterada aqui.",
    "selectSalesCategory": "Selecione uma categoria",
    "selectSalesCategoryFirst": "Selecione uma categoria neste card antes de ativar.",
    "salesCategorySaved": "Categoria de vendas salva com sucesso",
    "howToConfigure": "📌 Como Configurar",
    "mpStep1": "Acesse: Mercado Pago Developers",
    "mpStep2": "Vá em \"Suas integrações\" → \"Credenciais\"",
    "mpStep3": "Copie o \"Access Token\" de produção e cole acima",
    "mpStep4": "Configure o webhook no Mercado Pago com a URL fornecida",
    "mpStep5": "Ative as vendas desejadas",
    "mpStep6": "Compartilhe a URL pública com seus clientes!",
    "setDefaultGateway": "Definir como gateway padrão",
    "defaultGatewayHelp": "Gateway padrão será exibido primeiro para os clientes",
    "addFirstGateway": "Adicionar Primeiro Gateway",
    "configurePaymentMethods": "Configurar Métodos",
    "selectPaymentMethodsDesc": "Selecione quais métodos de pagamento você deseja oferecer aos seus clientes",
    "methodsSelected": "métodos selecionados",
    "noPaymentMethodsAvailable": "Nenhum método de pagamento disponível para esta região",
    "paymentMethodsUpdated": "Métodos de pagamento atualizados com sucesso",
    "asaasCredentials": "Credenciais Asaas",
    "asaasEnvironment": "Ambiente",
    "asaasEnvironmentProduction": "Produção",
    "asaasEnvironmentSandbox": "Sandbox",
    "asaasEnvironmentHelp": "Sandbox: chave $aact_hmlg_... em api-sandbox.asaas.com. Produção: chave $aact_prod_... em api.asaas.com. Nunca misture chave e ambiente.",
    "asaasApiKey": "API Key",
    "asaasApiKeyPlaceholder": "cole a sua API key do Asaas ($aact_hmlg_... ou $aact_prod_...)",
    "asaasApiKeyEditPlaceholder": "deixe em branco para manter a chave atual",
    "asaasApiKeyHelp": "Gere em Asaas → Integrações → API. Não cole aqui a URL do webhook do painel.",
    "asaasApiKeyStoredHint": "Chave API já salva. Preencha só se quiser trocar.",
    "asaasWebhookToken": "Token do Webhook",
    "asaasWebhookTokenPlaceholder": "opcional, defina o mesmo token no Asaas",
    "asaasWebhookTokenHelp": "Use este token para validar que as notificações são enviadas pelo Asaas.",
    "asaasWebhookDescription": "Configure esta URL em Asaas → Minha conta → Integrações → Webhooks para receber notificações de pagamento.",
    "asaasWebhookTokenRequiredHint": "No Asaas, use o mesmo token acima em «Token de autenticação». O Asaas envia no header asaas-access-token. A URL deve ser pública (ngrok/domínio) — localhost não recebe webhooks.",
    "pixEvpKey": "Chave PIX (EVP)",
    "pixEvpKeyPlaceholder": "ex: 123e4567-e89b-12d3-a456-426614174000",
    "pixEvpKeyHelp": "Cadastre esta chave EVP no painel Asaas (Pix → Chaves). A API v3 não envia a chave por cobrança; ela deve existir na conta.",
    "asaasPixOnly": "O Asaas disponibiliza apenas PIX neste momento. A opção fica fixa para garantir o fluxo.",
    "efiCredentials": "Credenciais EFI Bank",
    "efiEnvironment": "Ambiente",
    "efiEnvironmentProduction": "Produção",
    "efiEnvironmentSandbox": "Homologação",
    "efiEnvironmentHelp": "Use Homologação para testes (pix-h.api.efipay.com.br). Produção exige certificado de produção.",
    "efiClientIdPlaceholder": "Client_Id da aplicação PIX na conta Efí",
    "efiClientIdStoredHint": "Client_Id já salvo. Preencha só se quiser trocar.",
    "efiClientSecretPlaceholder": "Client_Secret da aplicação",
    "efiClientSecretEditPlaceholder": "deixe em branco para manter o secret atual",
    "efiCertificateP12": "Certificado .p12 / .pfx",
    "efiCertificateSelected": "Arquivo selecionado: {name}",
    "efiCertificateStoredHint": "Certificado já salvo. Envie outro arquivo apenas se quiser trocar.",
    "efiCertificateHelp": "Envie o certificado PFX (.p12) baixado em API → Meus Certificados no portal Efí. A API exige mTLS em todas as requisições (OAuth + Pix).",
    "efiCertificatePassphrase": "Senha do certificado",
    "efiCertificatePassphrasePlaceholder": "deixe vazio se o .p12 não tiver senha",
    "efiCertificatePassphraseHelp": "Alguns certificados Efí vêm protegidos por senha definida no portal. Se não tiver senha, deixe em branco.",
    "efiCertificateInvalidExtension": "Selecione um arquivo .p12 ou .pfx válido.",
    "efiCertificateReadError": "Não foi possível ler o arquivo do certificado.",
    "efiPixKeyHelp": "Chave PIX aleatória (EVP) cadastrada na conta Efí — usada para emitir cobranças.",
    "efiWebhookDescription": "Esta URL (?ignorar=) é registrada automaticamente na Efí ao salvar. A autenticação é mTLS no servidor web (Nginx/Apache), não por token.",
    "efiWebhookRequiredHint": "Configure mTLS no servidor com o certificado público da Efí. Produção: certificados.efipay.com.br/webhooks/certificate-chain-prod.crt — Homologação: certificate-chain-homolog.crt. IP de origem: 34.193.116.226.",
    "efiWebhookMtlsHelp": "A Efí valida mTLS na URL antes de registrar o webhook. Sem mTLS configurado no domínio, o cadastro falha com \"TLS mútuo não configurado\".",
    "efiPixOnly": "A EFI Bank disponibiliza apenas PIX neste momento.",
    "webhookUrl": "URL do Webhook (Global)",
    "webhookDescription": "Configure esta URL em Mercado Pago → Developers → Webhooks para receber notificações de pagamento",
    "webhookCopied": "URL do webhook copiada com sucesso",
    "accountSalesTitle": "Vendas de Contas",
    "accountSalesDesc": "Venda SSH/V2Ray automaticamente",
    "resellerSalesTitle": "Vendas de Revendas",
    "resellerSalesDesc": "Venda planos de revenda",
    "publicSalesUrl": "URL Pública de Vendas",
    "publicResellerUrl": "URL Pública de Revendas",
    "totalSales": "Total de vendas:",
    "totalRevenue": "Receita total:",
    "activeResellers": "Revendas ativas:",
    "categoryNotDefined": "Não definida",
    "goToAccountPlansTitle": "Ir para Planos de Conta?",
    "goToResellerPlansTitle": "Ir para Planos de Revenda?",
    "goToServersTitle": "Ir para Servidores?",
    "activeServersInCategory": "{count} servidor(es) ativo(s) nesta categoria",
    "noActiveServersInCategory": "Nenhum servidor ativo nesta categoria — necessário para planos SSH/Combo",
    "featureEnabledWithUrl": "Ativado! URL: {url}",
    "featureDisabled": "Desativado",
    "publicTestsTitle": "Testes Públicos Grátis",
    "publicTestsDesc": "Permita que clientes gerem testes pela web",
    "publicTestsGloballyDisabled": "Desativado globalmente pelo administrador",
    "publicTestsCategoryLabel": "Categoria dos testes públicos",
    "publicTestUrl": "URL Pública de Testes",
    "publicTestsInfo": "Duração: {duration}h • Cooldown global: {cooldown}h por e-mail"
  },
  "languageSelector": {
    "changed": "Idioma alterado para {language}!"
  },
  "modals": {
    "cancel": "Cancelar",
    "save": "Salvar",
    "create": "Criar",
    "edit": "Editar",
    "delete": "Excluir",
    "confirm": "Confirmar",
    "close": "Fechar",
    "loading": "Carregando...",
    "saving": "Salvando...",
    "deleting": "Excluindo...",
    "success": "Sucesso!",
    "error": "Erro",
    "confirmDelete": "Tem certeza que deseja excluir?",
    "required": "Campo obrigatório",
    "creating": "Criando...",
    "add": "Adicionar"
  },
  "reseller": {
    "portal": "Portal do Revendedor",
    "dashboard": "Dashboard",
    "welcome": "Bem-vindo, {name}",
    "dashboardSubtitle": "Gerencie suas vendas e acompanhe seu desempenho",
    "balance": "Saldo Disponível",
    "availableBalance": "Saldo Disponível",
    "role": "Revendedor",
    "totalClients": "Total de Clientes",
    "activeClients": "Clientes Ativos",
    "expiredClients": "Clientes Expirados",
    "recentSales": "Vendas Recentes",
    "quickActions": {
      "createSSH": "Criar Login SSH",
      "createV2Ray": "Criar Login V2Ray",
      "viewClients": "Ver Meus Clientes"
    },
    "quickSell": "Vender Rápido",
    "sell30Users": "Vender 30 Usuários",
    "sell20Users": "Vender 20 Usuários",
    "sell10Users": "Vender 10 Usuários",
    "viewClients": "Ver Clientes",
    "viewFullReport": "Ver Relatório Completo",
    "makeFirstSale": "Fazer Primeira Venda",
    "newSale": "Nova Venda",
    "newSaleSubtitle": "Preencha os dados para criar um novo cliente",
    "selectPlan": "Selecione o Plano",
    "plan": "Plano",
    "connections": "conexões",
    "username": "Nome de Usuário",
    "password": "Senha",
    "enterUsername": "Digite o nome de usuário",
    "enterPassword": "Digite a senha",
    "expiryDate": "Data de Vencimento",
    "sendNotification": "Enviar notificação ao cliente",
    "confirmSale": "Confirmar Venda",
    "saleSummary": "Resumo da Venda",
    "total": "Total",
    "tips": "Dicas",
    "tip1": "Use senhas fortes para segurança",
    "tip2": "Configure a data de vencimento adequada",
    "tip3": "O cliente receberá as credenciais por email",
    "myClients": "Meus Clientes",
    "myClientsSubtitle": "Gerencie todos os seus clientes",
    "newClient": "Novo Cliente",
    "searchClients": "Buscar por nome ou usuário...",
    "clientsFound": "clientes encontrados",
    "noClients": "Nenhum cliente cadastrado",
    "noClientsDescription": "Você ainda não possui clientes. Crie sua primeira venda!",
    "createFirstClient": "Criar Primeiro Cliente",
    "clientDetails": "Detalhes do Cliente",
    "server": "Servidor",
    "createdAt": "Criado em",
    "renew": "Renovar",
    "confirmDelete": "Tem certeza que deseja deletar o cliente {username}?",
    "deleteSuccess": "Cliente deletado com sucesso",
    "deleteError": "Erro ao deletar cliente",
    "renewFeature": "Funcionalidade de renovação em desenvolvimento",
    "editFeature": "Funcionalidade de edição em desenvolvimento",
    "expired": "Expirado",
    "expiringToday": "Expira hoje",
    "expiringTomorrow": "Expira amanhã",
    "daysRemaining": "{days} dias restantes",
    "salesReports": "Relatórios de Vendas",
    "salesReportsSubtitle": "Visualize e analise suas vendas",
    "exportReport": "Exportar Relatório",
    "startDate": "Data Inicial",
    "endDate": "Data Final",
    "revenue": "Faturamento",
    "newClients": "Novos Clientes",
    "averageTicket": "Ticket Médio",
    "salesHistory": "Histórico de Vendas",
    "noSalesInPeriod": "Nenhuma venda no período",
    "noSalesInPeriodDescription": "Não há vendas para o período selecionado",
    "noSales": "Nenhuma venda realizada",
    "noSalesDescription": "Você ainda não realizou nenhuma venda",
    "date": "Data",
    "client": "Cliente",
    "value": "Valor",
    "exportFeature": "Funcionalidade de exportação em desenvolvimento",
    "saleSuccess": "Venda realizada com sucesso!",
    "saleFailed": "Falha ao realizar venda",
    "saleError": "Erro ao processar venda",
    "errorLoadingClients": "Erro ao carregar clientes",
    "errorLoadingReports": "Erro ao carregar relatórios",
    "status": {
      "active": "Ativo",
      "expired": "Expirado",
      "pending": "Pendente"
    }
  },
  "adminManagement": {
    "title": "Gerenciamento de Administradores",
    "subtitle": "Gerencie administradores e moderadores do sistema (apenas Super Admin)",
    "newAdmin": "Novo Administrador",
    "reload": "Recarregar",
    "saveChanges": "Salvar Alterações",
    "filters": {
      "search": "Buscar",
      "searchPlaceholder": "ID, usuário, email, role, status, datas ou permissões...",
      "role": "Role",
      "allRoles": "Todos",
      "status": "Status",
      "allStatus": "Todos"
    },
    "stats": {
      "total": "Total de Admins",
      "active": "Ativos",
      "inactive": "Desativados"
    },
    "empty": {
      "title": "Nenhum administrador encontrado",
      "description": "Tente ajustar os filtros",
      "noAdmins": "Clique em \"Novo Administrador\" para criar o primeiro"
    },
    "table": {
      "administrator": "Administrador",
      "role": "Role",
      "status": "Status",
      "lastLogin": "Último Login",
      "createdAt": "Criado em",
      "actions": "Ações",
      "never": "Nunca"
    },
    "roles": {
      "super_admin": "Super Admin",
      "admin": "Admin",
      "moderator": "Moderador"
    },
    "status": {
      "active": "Ativo",
      "inactive": "Inativo"
    },
    "actions": {
      "activate": "Ativar",
      "deactivate": "Desativar",
      "edit": "Editar",
      "delete": "Deletar"
    },
    "modal": {
      "createTitle": "Novo Administrador",
      "editTitle": "Editar Administrador",
      "close": "Fechar",
      "cancel": "Cancelar",
      "save": "Salvar Alterações",
      "create": "Criar Administrador",
      "saving": "Salvando...",
      "deleting": "Deletando..."
    },
    "form": {
      "username": "Usuário",
      "usernamePlaceholder": "Ex: joao_admin",
      "usernameHelp": "3-50 caracteres alfanuméricos (não pode ser alterado depois)",
      "email": "Email",
      "emailPlaceholder": "email{'@'}example.com",
      "role": "Role",
      "adminRole": "Admin - Acesso completo",
      "moderatorRole": "Moderador - Acesso limitado",
      "roleHelp": "Super Admin não pode ser criado via interface",
      "password": "Senha",
      "newPassword": "Nova Senha (opcional)",
      "passwordPlaceholder": "Mínimo 6 caracteres",
      "passwordHelp": "Deixe em branco para manter a senha atual",
      "activeStatus": "Status Ativo",
      "activeStatusHelp": "Administrador pode fazer login"
    },
    "delete": {
      "title": "Confirmar Exclusão",
      "message": "Tem certeza que deseja deletar o administrador",
      "warning": "Esta ação não pode ser desfeita.",
      "confirm": "Deletar"
    },
    "messages": {
      "createSuccess": "Administrador criado com sucesso!",
      "updateSuccess": "Administrador atualizado com sucesso!",
      "deleteSuccess": "Administrador deletado com sucesso!",
      "statusChanged": "Status alterado com sucesso!",
      "createError": "Erro ao criar administrador",
      "updateError": "Erro ao atualizar administrador",
      "deleteError": "Erro ao deletar administrador",
      "loadError": "Erro ao carregar administradores",
      "superAdminOnly": "Apenas Super Admin pode acessar esta área.",
      "cannotDeactivateSelf": "Você não pode desativar sua própria conta"
    },
    "viewOnly": "Apenas visualização"
  },
  "resellers": {
    "title": "Revendedores",
    "subtitle": "Gerencie revendedores e seus créditos",
    "newReseller": "Novo Revendedor",
    "newResellerShort": "Novo",
    "deleteSelectedShort": "Excluir",
    "editReseller": "Editar Revendedor",
    "username": "Usuário",
    "email": "E-mail",
    "password": "Senha",
    "category": "Categoria",
    "planTypeLabel": "Tipo de Plano",
    "creditTypeDesc": "Pague por uso",
    "subscriptionTypeDesc": "Limite + validade",
    "creditResellerRestriction": "Revendedor tipo CRÉDITO só pode criar sub-revendedores e planos de CRÉDITO",
    "creditsPlaceholder": "Ex: 100",
    "durationDaysLabel": "Duração (dias)",
    "durationPlaceholder": "Ex: 30",
    "minDurationDaysHelp": "Mínimo: {min} dias",
    "loginLimitLabel": "Limite de Logins",
    "loginLimitPlaceholder": "Ex: 50",
    "newPasswordHelp": "Nova Senha (deixe vazio para manter)",
    "passwordRequired": "Senha",
    "expiresIn": "Expira em:",
    "expiresAt": "Data de expiração",
    "editExpiresAtHelp": "Defina manualmente a data e hora de validade da assinatura.",
    "editExpiresAtRequired": "Informe a data de expiração da assinatura.",
    "editLimitRequired": "Informe o limite de logins (mínimo 1).",
    "editLimitBelowUsage": "O limite não pode ser menor que os logins em uso ({used}).",
    "addDaysLabel": "Adicionar Dias",
    "newLimitLabel": "Novo Limite",
    "observationLabel": "Observação",
    "observationPlaceholder": "Motivo da alteração...",
    "typeCredit": "Crédito",
    "typeSubscription": "Assinatura",
    "selectCategory": "Selecione uma categoria",
    "initialCredits": "Créditos Iniciais",
    "filters": {
      "search": "Buscar",
      "searchPlaceholder": "Nome, usuário ou email...",
      "category": "Categoria",
      "allCategories": "Todas",
      "status": "Status",
      "allStatus": "Todos",
      "planType": "Tipo de plano",
      "allTypes": "Todos os tipos",
      "creatorType": "Tipo de criador",
      "allCreatorTypes": "Todos os tipos",
      "admins": "Admins",
      "resellersOnly": "Revendedores",
      "creator": "Criador",
      "allCreators": "Todos os criadores",
      "searchCreator": "Buscar criador...",
      "noCreatorsFound": "Nenhum criador encontrado"
    },
    "resellers_count": "revendas",
    "stats": {
      "total": "Total de Revendedores",
      "active": "Revendedores Ativos",
      "creditsDistributed": "Créditos Distribuídos",
      "slotsDistributed": "Slots Distribuídos",
      "distributedResources": "Recursos Distribuídos",
      "loginsCreated": "Logins Criados"
    },
    "table": {
      "reseller": "Revendedor",
      "category": "Categoria",
      "credits": "Créditos",
      "logins": "Logins",
      "active": "ativos",
      "used": "Usados",
      "status": "Status",
      "createdAt": "Criado em",
      "actions": "Ações",
      "type": "Tipo",
      "available": "disponíveis",
      "total": "total",
      "creditsLimit": "Créditos/Limite"
    },
    "modal": {
      "createTitle": "Novo Revendedor",
      "editTitle": "Editar Revendedor",
      "addCreditsTitle": "Adicionar Créditos",
      "currentBalance": "Saldo Atual",
      "credits": "créditos",
      "addButton": "Adicionar Créditos"
    },
    "form": {
      "username": "Usuário",
      "usernamePlaceholder": "Ex: joao_reseller",
      "email": "E-mail",
      "emailPlaceholder": "reseller{'@'}example.com",
      "password": "Senha",
      "newPassword": "Nova Senha (opcional)",
      "passwordPlaceholder": "Mínimo 6 caracteres",
      "passwordHelp": "Deixe em branco para manter a senha atual",
      "category": "Categoria",
      "selectCategory": "Selecione uma categoria",
      "initialCredits": "Créditos Iniciais",
      "credits": "Quantidade de Créditos",
      "creditsPlaceholder": "Ex: 100",
      "creditsHelp": "Use número negativo para remover créditos",
      "reason": "Motivo",
      "reasonPlaceholder": "Ex: Recarga manual, ajuste de saldo...",
      "activeStatus": "Status Ativo",
      "activeStatusHelp": "Revendedor pode fazer login e criar usuários"
    },
    "actions": {
      "addCredits": "Adicionar Créditos",
      "renewSubscription": "Renovar Assinatura",
      "viewAsReseller": "Visualizar como este revendedor",
      "activate": "Ativar",
      "deactivate": "Desativar"
    },
    "deleteModal": {
      "title": "Confirmar Exclusão",
      "question": "Tem certeza que deseja excluir o revendedor",
      "cannotUndo": "Esta ação não pode ser desfeita!",
      "creditsReturnTitle": "Créditos Serão Devolvidos",
      "creditsReturnBody": "{count} crédito(s) será(ão) restituído(s) ao revendedor:",
      "activeLoginsWarning": "Este revendedor possui {count} login(s) ativo(s)!",
      "deleting": "Excluindo..."
    },
    "renewSubscription": {
      "title": "Renovar Assinatura",
      "subtitle": "Escolha um plano para renovar sua assinatura de revenda.",
      "currentSubscription": "Sua Assinatura Atual",
      "slots": "Slots",
      "status": "Status",
      "expiresAt": "Expira em",
      "loadingPlans": "Carregando planos...",
      "noPlans": "Nenhum plano de renovação disponível.",
      "contactAdmin": "Entre em contato com seu administrador.",
      "slotsLabel": "slots",
      "confirmTitle": "Confirmar Renovação",
      "plan": "Plano",
      "duration": "Duração",
      "total": "Total",
      "paymentMethod": "Método de Pagamento",
      "processing": "Processando...",
      "payAmount": "Pagar R$ {amount}",
      "openPayment": "Abrir Pagamento",
      "loadError": "Erro ao carregar dados. Tente novamente.",
      "noGateway": "Nenhum gateway de pagamento configurado.",
      "paymentCreateError": "Erro ao criar pagamento",
      "paymentProcessError": "Erro ao processar pagamento"
    },
    "buyCredits": {
      "title": "Comprar Créditos",
      "subtitle": "Adquira créditos para criar e gerenciar contas de seus clientes.",
      "currentBalance": "Saldo Atual",
      "creditHint": "1 crédito = 1 conta criada por 30 dias",
      "loadingPlans": "Carregando planos...",
      "noPlans": "Nenhum pacote de créditos disponível.",
      "contactAdmin": "Entre em contato com seu administrador.",
      "perCredit": "crédito",
      "confirmTitle": "Confirmar Compra",
      "package": "Pacote",
      "creditsLabel": "Créditos",
      "balanceAfter": "Saldo após compra",
      "total": "Total",
      "paymentMethod": "Método de Pagamento",
      "processing": "Processando...",
      "payAmount": "Pagar R$ {amount}",
      "openPayment": "Abrir Pagamento",
      "loadError": "Erro ao carregar dados. Tente novamente.",
      "noGateway": "Nenhum gateway de pagamento configurado.",
      "paymentCreateError": "Erro ao criar pagamento",
      "paymentProcessError": "Erro ao processar pagamento"
    },
    "bulkDeleteConfirm": {
      "title": "Deletar {count} revendedor(es)?",
      "warning": "ATENÇÃO! Esta ação é IRREVERSÍVEL!",
      "question": "Deseja realmente DELETAR {count} revendedor(es)?",
      "moreCount": " e mais {count}",
      "bulletDb": "Serão removidos do banco de dados",
      "bulletAccountsKept": "Todas as contas criadas por eles serão removidas dos servidores e do banco",
      "bulletSalesKept": "Vendas serão mantidas para histórico",
      "finalWarning": "Esta ação NÃO pode ser desfeita!"
    },
    "bulkDeleteModal": {
      "title": "Excluir {count} revendedor(es)?",
      "keepOpenHint": "A exclusão continua em segundo plano. Aguarde até concluir."
    },
    "delete": {
      "title": "Confirmar Exclusão",
      "message": "Tem certeza que deseja deletar o revendedor",
      "warning": "Esta ação não pode ser desfeita. Revendedores com logins ativos não podem ser deletados.",
      "confirm": "Deletar"
    },
    "resultModal": {
      "title": "Revendedor criado com sucesso",
      "categoryLabel": "Categoria",
      "planLabel": "Plano",
      "expiresAtLabel": "Validade até",
      "accessTitle": "Dados de acesso",
      "createdModePlan": "Por plano",
      "createdModeManual": "Manual",
      "copyHint": "Copie os dados abaixo ou envie a mensagem pronta pelo WhatsApp/Telegram."
    },
    "messages": {
      "createSuccess": "Revendedor criado com sucesso!",
      "updateSuccess": "Revendedor atualizado com sucesso!",
      "deleteSuccess": "Revendedor deletado com sucesso!",
      "creditsSuccess": "Créditos ajustados com sucesso!",
      "createError": "Erro ao criar revendedor",
      "updateError": "Erro ao atualizar revendedor",
      "deleteError": "Erro ao deletar revendedor",
      "creditsError": "Erro ao ajustar créditos",
      "loadError": "Erro ao carregar revendedores",
      "impersonateSuccess": "Visualizando como: {username}",
      "impersonateError": "Erro ao entrar na conta do revendedor",
      "impersonateMissingUser": "Revendedor sem usuário associado"
    },
    "empty": {
      "title": "Nenhum revendedor encontrado",
      "description": "Tente ajustar os filtros",
      "noResellers": "Clique em \"Novo Revendedor\" para criar o primeiro"
    },
    "creditsModal": {
      "addCreditsTitle": "Adicionar Créditos",
      "adjustSubscriptionTitle": "Renovar/Ajustar Assinatura",
      "currentBalance": "Saldo Atual",
      "credits": "créditos",
      "amount": "Quantidade",
      "amountPlaceholder": "Ex: 100",
      "negativeHelp": "Use valor negativo para remover créditos",
      "observation": "Observação",
      "observationPlaceholder": "Motivo da alteração...",
      "currentStatus": "Status Atual",
      "limitHelp": "0 = manter atual ({current}). Em uso: {used} slots"
    },
    "createModal": {
      "manual": "Criação Manual",
      "byPlan": "Por Plano",
      "selectPlan": "Selecione um Plano",
      "choosePlan": "Escolha um plano...",
      "planDetails": "Detalhes do Plano",
      "planType": "Tipo",
      "price": "Preço",
      "usernameLabel": "Usuário",
      "usernamePlaceholder": "usuario_revendedor",
      "emailLabel": "E-mail",
      "emailPlaceholder": "revendedor{'@'}exemplo.com",
      "passwordLabel": "Senha",
      "passwordPlaceholder": "Senha de acesso",
      "autoCredentialsInfo": "Informe usuário, e-mail e senha de acesso do revendedor",
      "selectPlanError": "Selecione um plano e uma categoria",
      "categoryRequired": "Categoria é obrigatória",
      "successCreated": "Revendedor criado com sucesso!",
      "successUpdated": "Revendedor atualizado com sucesso!",
      "errorSaving": "Erro ao salvar revendedor"
    },
    "categoryInherited": "Categoria herdada automaticamente da sua conta de revendedor",
    "selectAll": "Selecionar Todos",
    "deleteSelected": "Deletar Selecionados",
    "days": "dias",
    "logins": "logins",
    "credits": "créditos",
    "blockedParentCredit": "🔒 Bloqueado (pai é Crédito)",
    "blockedParentSubscribe": "🔒 Bloqueado (pai é Assinatura)"
  },
  "dashboard": {
    "welcome": "Bem-vindo de volta, {name}",
    "goodMorning": "Bom dia! Veja o resumo do seu painel.",
    "goodAfternoon": "Boa tarde! Tudo funcionando perfeitamente.",
    "goodEvening": "Boa noite! Seu painel está operacional.",
    "refresh": "Atualizar",
    "createTest": "Criar Teste",
    "totalAccounts": "Total de Contas",
    "todayCount": "+{count} hoje",
    "activeCount": "✓ {count} ativas",
    "expiredCount": "✗ {count} expiradas",
    "servers": "Servidores",
    "serversOnline": "{count} online",
    "onlinePercentage": "{percent}% online",
    "activeConnections": "Conexões Ativas",
    "onlines": "Onlines",
    "onlinesDesc": "Suas contas conectadas agora",
    "onlinesTotal": "Onlines total",
    "onlinesTotalDesc": "Todas as contas do painel conectadas",
    "onlinesAdmin": "Onlines admin",
    "onlinesAdminDesc": "Contas do admin conectadas agora",
    "rightNow": "Agora mesmo",
    "realtimeMonitoring": "Monitoramento em tempo real",
    "expiringSoon": "Expirando em Breve",
    "next7Days": "Próximos 7 dias",
    "viewAccounts": "Ver contas",
    "disabled": "Desativadas",
    "accountsPaused": "Contas pausadas",
    "expired": "Expiradas",
    "awaitingRenewal": "Aguardando renovação",
    "thisWeek": "Esta Semana",
    "last7Days": "Últimos 7 dias",
    "thisMonth": "Este Mês",
    "credits": "Créditos",
    "creditsRemaining": "Créditos restantes",
    "buyCreditsHint": "Clique para comprar mais",
    "slots": "Slots",
    "slotsRemaining": "Slots restantes",
    "slotsInUse": "{used} de {total} em uso",
    "renewSlotsHint": "Clique para ampliar sua assinatura",
    "subscription": {
      "expiredBanner": "Sua assinatura expirou! Suas funcionalidades estão bloqueadas.",
      "expiringBanner": "Sua assinatura expira em {days} dia(s). Renove para continuar operando.",
      "renewNow": "Renovar Agora",
      "expiresTooltip": "Expira: {date}",
      "expired": "Expirado",
      "oneDay": "1 dia",
      "daysShort": "{days}d",
      "daysCount": "{days} dias",
      "daysRemaining": "Dias restantes",
      "accessExpiresAt": "Acesso válido até {date}",
      "managementPanel": "Painel de Gerenciamento"
    },
    "topResellers": "Top Revendedores",
    "topResellersDesc": "Revendedores com mais contas criadas",
    "position": "Posição",
    "reseller": "Revendedor",
    "activeAccounts": "Ativas",
    "activationRate": "Taxa de Ativação",
    "totalAccountsDesc": "Total no sistema",
    "totalAdmin": "Contas Admin",
    "totalAdminDesc": "Criadas pelo admin",
    "expiredAdmin": "Expirados Admin",
    "expiredAdminDesc": "Expiradas pelo admin",
    "salesToday": "Vendas Hoje",
    "salesMonth": "Vendas do Mês",
    "salesTotal": "Receita Total",
    "salesCount": "{count} venda(s)",
    "salesTrend": "Tendência de Vendas",
    "accountGrowth": "Crescimento de Contas"
  },
  "salesMetrics": {
    "title": "Métricas de Vendas",
    "subtitle": "Acompanhe o desempenho financeiro e histórico de pagamentos",
    "totalRevenue": "Receita Total",
    "monthRevenue": "Receita do Mês",
    "todayRevenue": "Receita Hoje",
    "pendingPayments": "Pagamentos Pendentes",
    "awaitingConfirmation": "Aguardando confirmação",
    "sales": "venda(s)",
    "revenue": "Receita",
    "revenueLast30Days": "Receita — Últimos 30 Dias",
    "revenueByMonth": "Receita por Mês",
    "byProductType": "Por Tipo de Produto",
    "byGateway": "Por Gateway",
    "paymentsHistory": "Histórico de Pagamentos",
    "allStatuses": "Todos os status",
    "allTypes": "Todos os tipos",
    "statusApproved": "Aprovado",
    "statusPending": "Pendente",
    "statusCancelled": "Cancelado",
    "statusExpired": "Expirado",
    "typeAccount": "Conta VPN",
    "typeReseller": "Revendedor",
    "typeResellerRenewal": "Renovação de revenda",
    "typeResellerCredits": "Compra de créditos",
    "typeOther": "Outros",
    "emptyValue": "—",
    "monthYearLabel": "{month}/{year}",
    "monthsShort": [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez"
    ],
    "gateways": {
      "mercadopago": "Mercado Pago",
      "asaas": "Asaas",
      "paypal": "PayPal",
      "manual": "Manual",
      "pagseguro": "PagSeguro"
    },
    "dateFrom": "Data inicial",
    "dateTo": "Data final",
    "colDate": "Data",
    "colDescription": "Descrição",
    "colCustomer": "Cliente",
    "colType": "Tipo",
    "colGateway": "Gateway",
    "colStatus": "Status",
    "colValue": "Valor",
    "noData": "Sem dados no período",
    "noPayments": "Nenhum pagamento encontrado",
    "page": "Página",
    "records": "registro(s)",
    "prev": "Anterior",
    "next": "Próxima"
  },
  "notFound": {
    "documentTitle": "404 — {panel}",
    "page_title": "Página não encontrada",
    "subtitle": "O endereço pode estar incorreto ou a página foi removida",
    "title": "Não encontramos esta rota",
    "message": "Verifique se o link está correto ou use os atalhos abaixo para voltar ao painel.",
    "attempted_path": "Endereço acessado",
    "suggestions": "Atalhos úteis",
    "goBack": "Voltar",
    "goHome": "Ir para o dashboard",
    "help_hint": "Se o problema persistir, contacte o administrador do painel",
    "needHelp": "Precisa de ajuda?",
    "contactSupport": "Entre em contato",
    "dashboardDesc": "Visão geral do sistema",
    "accountsDesc": "Gerenciar contas",
    "serversDesc": "Gerenciar servidores",
    "settingsDesc": "Configurações do painel"
  },
  "publicStoreAlerts": {
    "ok": "OK",
    "notice": "Aviso",
    "warning": "Atenção",
    "info": "Informação"
  },
  "publicStore": {
    "types": {
      "ssh": "SSH",
      "v2ray": "V2Ray",
      "combo": "SSH + V2Ray"
    },
    "account": {
      "subtitle": "Escolha seu plano de acesso SSH/V2Ray",
      "loadingPlans": "Carregando planos...",
      "validityDays": "{days} dias de validade",
      "unlimitedConnections": "Conexões ilimitadas",
      "connectionsCount": "{count} conexões",
      "instantActivation": "Ativação imediata",
      "support247": "Suporte 24/7",
      "buyNow": "Comprar Agora",
      "noPlans": "Nenhum plano disponível no momento.",
      "noServersInCategoryTitle": "Loja temporariamente indisponível",
      "noServersInCategory": "Não existem servidores ativos na categoria definida para vendas. Entre em contato com o vendedor.",
      "filterPlans": "Filtrar planos por tipo"
    },
    "reseller": {
      "subtitle": "Torne-se um revendedor — escolha seu plano",
      "loadingPlans": "Carregando planos...",
      "typeCredit": "Crédito",
      "typeSubscribe": "Assinatura",
      "filterPlans": "Filtrar planos por tipo",
      "creditsAmount": "{count} créditos",
      "durationDays": "{days} dias",
      "simultaneousLogins": "{count} logins simultâneos",
      "managementPanel": "Painel de gerenciamento",
      "instantActivation": "Ativação imediata",
      "fullSupport": "Suporte completo",
      "commonBenefits": "Painel de gerenciamento • Ativação imediata • Suporte completo",
      "becomeReseller": "Tornar-se Revendedor",
      "noPlans": "Nenhum plano de revenda disponível no momento."
    }
  },
  "publicPayment": {
    "checkout": "Finalizar Compra",
    "selectedPlan": "Plano selecionado",
    "planSummary": "{days} dias • {connections} conexões",
    "fullName": "Nome Completo",
    "email": "Email",
    "cpf": "CPF",
    "dni": "DNI",
    "curp": "CURP",
    "rut": "RUT",
    "cc": "Cédula",
    "ci": "CI",
    "documentLabel": "{doc}",
    "whatsappOptional": "WhatsApp (opcional)",
    "telegramOptional": "Telegram (opcional)",
    "placeholderName": "Seu nome",
    "payerNameHint": "Nome completo do titular do documento (obrigatório no Mercado Pago)",
    "placeholderEmail": "seu{'@'}email.com",
    "placeholderCpf": "000.000.000-00",
    "placeholderDocument": "Documento do pagador",
    "placeholderWhatsapp": "(11) 99999-9999",
    "placeholderTelegram": "{'@'}usuario ou ID",
    "cancel": "Cancelar",
    "continue": "Continuar",
    "back": "Voltar",
    "paymentMethodTitle": "Forma de Pagamento",
    "processing": "Processando...",
    "payNow": "Pagar Agora",
    "noPaymentMethods": "Nenhum método de pagamento disponível",
    "paymentCreateError": "Erro ao criar pagamento. Tente novamente.",
    "cpfInvalid": "Informe um CPF válido (11 dígitos, dígitos verificadores corretos).",
    "cpfAutoFillHint": "CPF gerado automaticamente para agilizar o pagamento. Você pode editar ou gerar outro.",
    "regenerateCpf": "Gerar outro",
    "documentInvalid": "Informe um documento válido ({doc}).",
    "dataAlreadyExists": "Dados já existem",
    "resellerCredentialsTitle": "Credenciais de Acesso ao Painel",
    "resellerCredentialsHelp": "Escolha suas credenciais para acessar o painel de revendedor",
    "username": "Usuário",
    "usernameTaken": "Usuário já está em uso. Escolha outro.",
    "usernameAvailable": "Usuário disponível!",
    "usernameRequired": "Informe um usuário.",
    "checkingUsername": "Verificando usuário...",
    "usernameCheckError": "Não foi possível verificar o usuário. Tente novamente.",
    "emailTaken": "Email já está em uso. Escolha outro.",
    "emailAvailable": "Email disponível!",
    "checkingEmail": "Verificando email...",
    "emailCheckError": "Não foi possível verificar o email. Tente novamente.",
    "checkingCredentials": "Verificando dados...",
    "payerNameRequired": "Informe o nome completo do pagador.",
    "nameRequired": "Informe seu nome completo.",
    "emailRequired": "Informe um e-mail.",
    "emailInvalid": "Informe um e-mail válido.",
    "cpfRequired": "Informe o CPF.",
    "documentRequired": "Informe o {doc}.",
    "payerDocumentSectionTitle": "Documento do pagador",
    "payerDocumentSectionHint": "Obrigatório para pagamento com {method}.",
    "payerDocumentSectionHintPayment": "Documento enviado na requisição de pagamento com {method}.",
    "payerDocumentSectionHintCustomer": "CPF/CNPJ usado no cadastro do cliente no gateway (reutilizado em cobranças futuras). Obrigatório para {method}.",
    "passwordRequired": "A senha deve ter no mínimo 6 caracteres.",
    "usernamePlaceholder": "seunome123",
    "emailForLogin": "Email",
    "emailForLoginHint": "(para login no painel)",
    "emailPlaceholder": "email{'@'}painel.com",
    "password": "Senha",
    "passwordHint": "(mínimo 6 caracteres)",
    "methodInstant": "Instantâneo",
    "methodCash": "Dinheiro",
    "methodCard": "Cartão",
    "methodBankTransfer": "Transferência",
    "methodWallet": "Carteira",
    "pixTitle": "Pagamento PIX",
    "cardMissingPublicKey": "Cartão indisponível: o vendedor precisa configurar a Public Key do Mercado Pago.",
    "cardInvalidPublicKey": "Public Key inválida. Use a chave pública (TEST-... ou APP_USR-...), não o Access Token.",
    "cardAccessTokenInsteadOfPublicKey": "Parece que o Access Token foi colocado no lugar da Public Key. No painel MP: Credenciais → copie a Chave pública (Public Key), não o Token de acesso.",
    "cardInvalidAmount": "Valor do plano inválido para pagamento com cartão.",
    "cardBrickGetPaymentMethodsFailed": "O Mercado Pago rejeitou a Public Key (erro get_payment_methods_failed). Confira em Automações → Gateways: chave pública correta, aplicação ativa e mesmo ambiente (teste/produção) que o Access Token.",
    "cardBrickProductionKeyOnLocalhost": "Você está em localhost com chave de produção (APP_USR-). Para testar localmente, use credenciais de teste (TEST-) ou publique em HTTPS com domínio real.",
    "cardBrickSecureFieldsFailed": "Falha ao carregar os campos seguros do cartão. Verifique bloqueadores de script/iframe e recarregue a página.",
    "cardNumberLabel": "Número do cartão",
    "cardNumberPlaceholder": "0000 0000 0000 0000",
    "cardNumberInvalid": "Número de cartão inválido. Verifique os dígitos informados.",
    "cardNumberIncomplete": "Informe o número completo do cartão.",
    "cardExpiryLabel": "Validade",
    "cardExpiryMonthLabel": "Mês",
    "cardExpiryYearLabel": "Ano",
    "cardYearInvalid": "Informe o ano com 4 dígitos (ex.: 2030).",
    "cardTestOnProduction": "Você está usando cartão de TESTE com chave de PRODUÇÃO (APP_USR). Cartões de teste só funcionam com credenciais TEST-. Use um cartão real ou troque para sandbox.",
    "cardSandboxHint": "Sandbox: no Nome use APRO (ok), OTHE (erro), CONT (pendente), CALL, FUND, SECU, EXPI, FORM, DUPL, LOCK… CPF teste: 12345678909.",
    "cardCvvLabel": "CVV",
    "cardHolderLabel": "Nome no cartão",
    "cardHolderHint": "Como impresso no cartão — usado no pagamento. O nome do comprador no passo anterior é só para cadastro da conta.",
    "cardHolderRequired": "Informe o nome impresso no cartão.",
    "cardDeviceSessionMissing": "Não foi possível ler a sessão antifraude do Mercado Pago. Recarregue com Ctrl+F5, aguarde 5 segundos na tela do cartão e tente de novo.",
    "cardDeviceSessionPending": "Carregando sessão antifraude do Mercado Pago… aguarde alguns segundos antes de pagar.",
    "cardHolderPlaceholder": "Como impresso no cartão",
    "cardHolderPlaceholderSandbox": "APRO",
    "cardInstallmentsLabel": "Parcelas",
    "cardInstallmentsPlaceholder": "Digite o cartão para carregar",
    "cardInstallmentsHint": "As parcelas são calculadas pelo Mercado Pago após informar o número do cartão.",
    "cardInstallmentsLoading": "Calculando parcelas…",
    "cardInstallmentsLowAmount": "Valor baixo: normalmente só à vista (1x). Teste com plano acima de R$ 5 para ver parcelas.",
    "cardBrickError": "Não foi possível carregar o formulário de cartão. Recarregue a página e tente novamente.",
    "cardTokenError": "Não foi possível tokenizar o cartão. Confira número, validade, CVV e tente novamente.",
    "cardProcessing": "Processando pagamento com cartão",
    "cardPending": "Pagamento em análise. Aguarde a confirmação ou tente novamente em instantes.",
    "cardApprovedAwaitingDelivery": "Pagamento aprovado. A entrega está sendo processada — atualize em alguns segundos se a confirmação não aparecer.",
    "pixStepScan": "Escaneie o QR",
    "pixStepPay": "Confirme no app",
    "pixStepWait": "Aguarde aqui",
    "pixExpiresIn": "Expira em ~{minutes} min",
    "pixExpired": "PIX expirado",
    "pixScanHint": "Escaneie com o app do seu banco",
    "pixCopyLabel": "Ou copie a chave PIX:",
    "copy": "Copiar",
    "copied": "Copiado!",
    "pixInstructions": "Abra o app do seu banco → PIX → Ler QR Code ou Colar Chave",
    "awaitingConfirmation": "Aguardando confirmação...",
    "cancelPayment": "Cancelar Pagamento",
    "cancelling": "Cancelando...",
    "close": "Fechar",
    "pixExpiresHint": "O PIX expira automaticamente se não for pago",
    "paymentConfirmed": "Pagamento Confirmado!",
    "accountCreated": "Sua conta foi criada com sucesso",
    "accountRenewed": "Sua conta foi renovada com sucesso",
    "resellerActivated": "Seu painel de revendedor foi ativado!",
    "creditsAddedSuccess": "Créditos adicionados com sucesso!",
    "creditsAddedLabel": "Créditos adicionados",
    "newCreditsBalance": "Novo saldo",
    "creditsPurchaseToast": "+{added} créditos adicionados! Saldo atual: {balance}",
    "validUntil": "Válido até: {date}",
    "userLabel": "Usuário",
    "passwordLabel": "Senha",
    "uuidLabel": "UUID (V2Ray)",
    "copyAllCredentials": "Copiar Todas as Credenciais",
    "copyResellerCredentials": "Copiar Credenciais de Acesso",
    "typeLabel": "Tipo",
    "limitLabel": "Limite",
    "creditsLabel": "Créditos",
    "resellerPanelCredentials": "Credenciais do Painel de Revendedor",
    "panelUrl": "URL do Painel",
    "saveCredentialsWarning": "Guarde estas informações em local seguro!",
    "cancelPaymentConfirm": "Tem certeza que deseja cancelar este pagamento?\n\nO PIX não poderá mais ser pago após o cancelamento.",
    "cancelPaymentError": "Erro ao cancelar pagamento. Tente novamente.",
    "copyManualPrompt": "Clique OK para ver suas credenciais e copie manualmente:",
    "copyManualTitle": "Copie estas credenciais (Ctrl+C):",
    "successTitle": "Pagamento Aprovado!",
    "successSubtitle": "Suas credenciais estão prontas",
    "credentialsSentEmail": "As credenciais também foram enviadas para seu email.",
    "resellerWelcome": "Bem-vindo!",
    "resellerSuccessSubtitle": "Sua revenda foi ativada com sucesso",
    "resellerLoginHint": "Faça login no painel para começar!",
    "resellerEmailSent": "Os dados de acesso foram enviados para seu email.",
    "successModal": {
      "expiresAtLabel": "Válido até",
      "connectionLimitLabel": "Limite de conexões",
      "loginLimitValue": "{limit} logins"
    }
  },
  "renewal": {
    "title": "Renovar Acesso",
    "subtitle": "Renove sua conta SSH/V2Ray de forma rápida e segura",
    "step1Title": "Encontre sua conta",
    "usernameOrUuidLabel": "Usuário ou UUID V2Ray",
    "usernameOrUuidPlaceholder": "Digite seu usuário ou UUID",
    "usernameOrUuidHelp": "Insira o usuário da conta SSH ou UUID do V2Ray",
    "searchButton": "Buscar Conta",
    "searching": "Buscando...",
    "accountNotFound": "Conta não encontrada",
    "searchError": "Erro ao buscar conta. Tente novamente.",
    "accountFound": "Conta Encontrada!",
    "accountFoundSubtitle": "Escolha um plano para renovar",
    "username": "Usuário",
    "type": "Tipo",
    "expiresAt": "Validade",
    "status": "Status",
    "expired": "Expirada",
    "active": "Ativa",
    "availablePlans": "Planos Disponíveis",
    "loadingPlans": "Carregando planos...",
    "days": "dias",
    "connections": "conexões",
    "renewNow": "Renovar Agora",
    "renewPlanSummary": "+{days} dias • conta {username}",
    "noPlansAvailable": "Nenhum plano disponível para renovação",
    "payment": "Pagamento",
    "changePlan": "Trocar plano",
    "selectedPlan": "Plano selecionado",
    "customerName": "Nome Completo",
    "optional": "opcional",
    "paymentMethod": "Método de pagamento",
    "noPaymentMethods": "Nenhum método de pagamento disponível.",
    "processing": "Processando...",
    "payNow": "Pagar agora",
    "paymentCreateError": "Erro ao criar pagamento",
    "paymentProcessError": "Erro ao processar pagamento",
    "successTitle": "Renovação concluída!",
    "newExpiresAt": "Nova validade: {date}",
    "typeSsh": "SSH",
    "typeV2ray": "V2Ray",
    "typeCombo": "SSH + V2Ray"
  },
  "nav": {
    "dashboard": "Dashboard",
    "accounts": "Contas",
    "servers": "Servidores",
    "categories": "Categorias",
    "resellers": "Revendedores",
    "payments": "Pagamentos",
    "gateways": "Gateways",
    "coupons": "Cupons",
    "announcements": "Avisos",
    "salesMetrics": "Métricas",
    "settings": "Configurações",
    "profile": "Perfil",
    "logout": "Sair",
    "panel": "Painel",
    "manage": "Gerenciar",
    "plans": "Planos",
    "system": "Sistema",
    "administrators": "Administradores",
    "branding": "Branding",
    "checkuser": "CheckUser",
    "manageBackup": "Gerenciar Backup",
    "systemLogs": "Logs do Sistema",
    "users": "Usuários",
    "automaticResale": "Revenda Automática",
    "portal": "Portal",
    "createLogin": "Criar Login",
    "devices": "Dispositivos",
    "paymentHistory": "Histórico de Pagamentos",
    "configuration": "Configuração",
    "myUsers": "Meus Usuários",
    "documentation": "Documentação",
    "publicApiDocs": "APIs Públicas"
  },
  "deletionJobs": {
    "started": "Exclusão iniciada em segundo plano…",
    "startedBulk": "Exclusão de {count} conta(s) iniciada…",
    "startedBulkResellers": "Exclusão de {count} revendedor(es) iniciada…",
    "running": "A eliminar nos servidores…",
    "serversSync": "A eliminar dos servidores…",
    "databaseSync": "A eliminar do banco de dados…",
    "progress": "{processed} de {total} processado(s)",
    "progressSteps": "Etapa {step} de {serverSteps} — servidores",
    "progressServer": "Servidor {step} de {serverSteps}: {name}",
    "progressPercent": "{percent}% concluído",
    "progressReseller": "Revendedor {step} de {total}",
    "uncertain": "A exclusão pode ainda estar em curso. A lista será atualizada — verifique em instantes.",
    "completed": "Exclusão concluída",
    "failed": "Falha na exclusão",
    "syncWarningsTitle": "Avisos de sincronização com servidores:",
    "syncWarningsMore": "… e mais {count} servidor(es) com aviso.",
    "syncUnknownError": "Falha ao sincronizar"
  },
  "common": {
    "dashboard": "Dashboard",
    "yes": "Sim",
    "no": "Não",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "save": "Salvar",
    "saveNow": "Salvar Agora",
    "discard": "Descartar",
    "delete": "Excluir",
    "remove": "Remover",
    "edit": "Editar",
    "add": "Adicionar",
    "create": "Criar",
    "update": "Atualizar",
    "search": "Pesquisar",
    "filter": "Filtrar",
    "export": "Exportar",
    "import": "Importar",
    "refresh": "Atualizar",
    "loading": "Carregando...",
    "noData": "Nenhum dado disponível",
    "actions": "Ações",
    "status": "Status",
    "active": "Ativo",
    "inactive": "Inativo",
    "prevPage": "Anterior",
    "nextPage": "Próxima",
    "paginationSummary": "Página {page} de {totalPages} · {total} registros",
    "confirmClearNotifications": "Limpar notificações?",
    "confirmClearNotificationsDesc": "Deseja realmente limpar todas as notificações? Esta ação não pode ser desfeita.",
    "enabled": "Ativado",
    "disabled": "Desativado",
    "success": "Sucesso",
    "error": "Erro",
    "warning": "Aviso",
    "info": "Informação",
    "close": "Fechar",
    "copy": "Copiar",
    "back": "Voltar",
    "next": "Próximo",
    "previous": "Anterior",
    "finish": "Finalizar",
    "total": "Total",
    "from": "De",
    "to": "Até",
    "date": "Data",
    "time": "Hora",
    "name": "Nome",
    "description": "Descrição",
    "details": "Detalhes",
    "settings": "Configurações",
    "profile": "Perfil",
    "logout": "Sair",
    "toggleTheme": "Alternar tema",
    "login": "Entrar",
    "register": "Registrar",
    "username": "Usuário",
    "password": "Senha",
    "email": "E-mail",
    "phone": "Telefone",
    "address": "Endereço",
    "required": "Obrigatório",
    "optional": "Opcional",
    "select": "Selecionar",
    "selectAll": "Selecionar Todos",
    "deselectAll": "Desmarcar Todos",
    "perPage": "Por página",
    "showing": "Mostrando",
    "of": "de",
    "results": "resultados",
    "ok": "OK",
    "selectPlaceholder": "Selecione...",
    "copied": "Copiado!",
    "copyError": "Erro ao copiar",
    "copiedWithLabel": "{label} copiado!",
    "copyManual": "Erro ao copiar. Copie manualmente (Ctrl+C)",
    "noItems": "Nenhum item encontrado",
    "noItemsDescription": "Não há dados para exibir",
    "itemsSelected": "{count} item(s) selecionado(s)",
    "itemsPerPage": "Itens por página:",
    "pageOf": "{current} de {total}",
    "firstPage": "Primeira página",
    "prevPageTitle": "Página anterior",
    "nextPageTitle": "Próxima página",
    "lastPage": "Última página",
    "user": "Usuário",
    "expand": "Expandir menu",
    "collapse": "Recolher menu",
    "menu": "Menu",
    "showPassword": "Mostrar senha",
    "hidePassword": "Ocultar senha",
    "open": "Abrir",
    "uuid": "UUID",
    "panelLink": "Link do painel",
    "notAvailable": "N/D",
    "day": "dia",
    "days": "dias",
    "unknownError": "Erro desconhecido",
    "roles": {
      "super_admin": "Super Administrador",
      "admin": "Administrador",
      "reseller": "Revendedor",
      "sub_reseller": "Sub-revendedor",
      "user": "Usuário"
    },
    "closeModal": "Fechar modal",
    "closeNotification": "Fechar notificação",
    "closeTab": "Fechar aba {label}",
    "closeError": "Fechar erro",
    "saving": "Salvando..."
  },
  "auth": {
    "login": "Entrar",
    "logout": "Sair",
    "loginTitle": "Bem-vindo de volta",
    "loginSubtitle": "Entre com seu usuário ou email e a senha do painel",
    "loginIdentifier": "Usuário ou email",
    "loginIdentifierPlaceholder": "admin ou admin{'@'}seudominio.com",
    "systemDescription": "Sistema de gerenciamento de contas SSH/V2Ray moderno e eficiente",
    "email": "Email",
    "emailPlaceholder": "admin{'@'}seudominio.com",
    "username": "Usuário",
    "password": "Senha",
    "passwordPlaceholder": "Digite sua senha",
    "rememberMe": "Lembrar de mim",
    "forgotPassword": "Esqueceu a senha?",
    "forgotPasswordTitle": "Recuperar senha",
    "forgotPasswordSubtitle": "Informe o e-mail cadastrado no painel. Enviaremos um link para redefinir sua senha.",
    "forgotPasswordSubmit": "Enviar link",
    "forgotPasswordSent": "Se o e-mail estiver cadastrado, você receberá instruções em breve. Verifique também o spam.",
    "forgotPasswordError": "Não foi possível processar a solicitação. Tente novamente.",
    "backToLogin": "Voltar ao login",
    "resetPasswordTitle": "Nova senha",
    "resetPasswordSubtitle": "Defina uma nova senha para {username}",
    "resetPasswordNew": "Nova senha",
    "resetPasswordConfirm": "Confirmar senha",
    "resetPasswordSubmit": "Redefinir senha",
    "resetPasswordSuccess": "Senha redefinida com sucesso. Faça login com a nova senha.",
    "resetPasswordInvalidToken": "Link inválido ou expirado. Solicite um novo reset de senha.",
    "resetPasswordMismatch": "As senhas não coincidem",
    "resetPasswordError": "Não foi possível redefinir a senha",
    "passwordRequirements": "Mínimo 6 caracteres, com maiúscula, minúscula e número.",
    "loginButton": "Entrar no Painel",
    "loggingIn": "Entrando...",
    "loginSuccess": "Login realizado com sucesso!",
    "loginError": "Erro no login",
    "tryAgain": "Tentar novamente",
    "checkCredentials": "Verifique suas credenciais",
    "invalidCredentials": "Usuário ou senha incorretos",
    "tooManyAttempts": "Muitas tentativas de login. Tente novamente em alguns minutos.",
    "sessionExpired": "Sessão expirada. Faça login novamente.",
    "contactAdmin": "Entre em contato com o administrador para recuperar sua senha",
    "impersonate": {
      "banner": "Visualizando como: {username} ({role})",
      "stopAdmin": "Voltar ao Admin",
      "stopReseller": "Voltar à minha conta"
    },
    "sessionExpiration": {
      "title": "Sessão expirando",
      "message": "Sua sessão expira por inatividade em breve. Clique em \"Continuar conectado\" para permanecer logado.",
      "timeRemaining": "Tempo restante de inatividade",
      "tip": "Clique em \"Continuar conectado\" para renovar agora.",
      "logoutNow": "Sair agora",
      "extending": "Renovando...",
      "stayConnected": "Continuar conectado",
      "refreshFailed": "Não foi possível renovar a sessão. Faça login novamente ou tente outra vez."
    }
  },
  "users": {
    "title": "Gerenciar Usuários",
    "addUser": "Adicionar Usuário",
    "editUser": "Editar Usuário",
    "deleteUser": "Excluir Usuário",
    "deleteConfirm": "Tem certeza que deseja excluir este usuário?",
    "username": "Usuário",
    "password": "Senha",
    "email": "E-mail",
    "status": "Status",
    "expirationDate": "Data de Expiração",
    "createdAt": "Criado em",
    "updatedAt": "Atualizado em",
    "connectionLimit": "Limite de Conexões",
    "daysRemaining": "Dias Restantes",
    "renew": "Renovar",
    "suspend": "Suspender",
    "activate": "Ativar",
    "resetPassword": "Resetar Senha",
    "details": "Detalhes do Usuário",
    "active": "Ativo",
    "suspended": "Suspenso",
    "expired": "Expirado",
    "filterByStatus": "Filtrar por Status",
    "searchUser": "Pesquisar usuário",
    "userCreated": "Usuário criado com sucesso",
    "userUpdated": "Usuário atualizado com sucesso",
    "userDeleted": "Usuário excluído com sucesso",
    "userRenewed": "Usuário renovado com sucesso",
    "userSuspended": "Usuário suspenso com sucesso",
    "userActivated": "Usuário ativado com sucesso"
  },
  "ssh": {
    "title": "Contas SSH",
    "addAccount": "Adicionar Conta",
    "editAccount": "Editar Conta",
    "deleteAccount": "Excluir Conta",
    "deleteConfirm": "Tem certeza que deseja excluir esta conta SSH?",
    "username": "Usuário",
    "password": "Senha",
    "server": "Servidor",
    "port": "Porta",
    "expirationDate": "Data de Expiração",
    "status": "Status",
    "connectionLimit": "Limite de Conexões",
    "currentConnections": "Conexões Atuais",
    "createdAt": "Criado em",
    "lastConnection": "Última Conexão",
    "testConnection": "Testar Conexão",
    "copyConfig": "Copiar Configuração",
    "downloadConfig": "Baixar Configuração",
    "connectionString": "String de Conexão",
    "accountCreated": "Conta SSH criada com sucesso",
    "accountUpdated": "Conta SSH atualizada com sucesso",
    "accountDeleted": "Conta SSH excluída com sucesso",
    "configCopied": "Configuração copiada para a área de transferência"
  },
  "v2ray": {
    "title": "Contas V2Ray",
    "addAccount": "Adicionar Conta",
    "editAccount": "Editar Conta",
    "deleteAccount": "Excluir Conta",
    "deleteConfirm": "Tem certeza que deseja excluir esta conta V2Ray?",
    "username": "Usuário",
    "uuid": "UUID",
    "alterId": "AlterID",
    "server": "Servidor",
    "port": "Porta",
    "network": "Rede",
    "tls": "TLS",
    "expirationDate": "Data de Expiração",
    "status": "Status",
    "protocol": "Protocolo",
    "vmess": "VMess",
    "vless": "VLess",
    "trojan": "Trojan",
    "generateUUID": "Gerar UUID",
    "qrCode": "QR Code",
    "viewQRCode": "Ver QR Code",
    "copyLink": "Copiar Link",
    "downloadConfig": "Baixar Configuração",
    "accountCreated": "Conta V2Ray criada com sucesso",
    "accountUpdated": "Conta V2Ray atualizada com sucesso",
    "accountDeleted": "Conta V2Ray excluída com sucesso",
    "linkCopied": "Link copiado para a área de transferência"
  },
  "settings": {
    "title": "Configurações",
    "general": "Geral",
    "system": "Sistema",
    "security": "Segurança",
    "notifications": "Notificações",
    "appearance": "Aparência",
    "advanced": "Avançado",
    "siteName": "Nome do Site",
    "siteUrl": "URL do Site",
    "adminEmail": "E-mail do Administrador",
    "timezone": "Fuso Horário",
    "language": "Idioma",
    "currency": "Moeda",
    "theme": "Tema",
    "lightMode": "Modo Claro",
    "darkMode": "Modo Escuro",
    "autoMode": "Automático",
    "enableRegistration": "Habilitar Registro",
    "requireEmailVerification": "Exigir Verificação de E-mail",
    "maxLoginAttempts": "Máximo de Tentativas de Login",
    "sessionTimeout": "Tempo de Sessão (minutos)",
    "twoFactorAuth": "Autenticação de Dois Fatores",
    "backupSettings": "Backup de Configurações",
    "exportSettings": "Exportar Configurações",
    "importSettings": "Importar Configurações",
    "resetToDefaults": "Restaurar Padrões",
    "saveChanges": "Salvar Alterações",
    "settingsSaved": "Configurações salvas com sucesso",
    "settingsError": "Erro ao salvar configurações"
  },
  "coupons": {
    "title": "Cupons de Desconto",
    "subtitle": "Crie e gerencie cupons de desconto para seus clientes",
    "newCoupon": "Novo Cupom",
    "newCouponShort": "Novo",
    "createCoupon": "Criar Cupom",
    "editCoupon": "Editar Cupom",
    "deleteCoupon": "Excluir Cupom",
    "code": "Código",
    "discountType": "Tipo de Desconto",
    "percentage": "Percentual",
    "fixedValue": "Valor Fixo",
    "discountAmount": "Valor do Desconto",
    "percentLabel": "Percentual (%)",
    "fixedLabel": "Valor (R$)",
    "maxUses": "Usos Máximos",
    "validUntil": "Válido até",
    "activate": "Ativar",
    "deactivate": "Desativar",
    "active": "Ativo",
    "inactive": "Inativo",
    "total": "Total",
    "activeCount": "Ativos",
    "uses": "Usos",
    "emptyTitle": "Nenhum cupom",
    "emptyHint": "Crie seu primeiro cupom de desconto",
    "discountLabel": "Desconto:",
    "usesLabel": "Usos:",
    "validUntilLabel": "Válido até:",
    "codePlaceholder": "DESC10",
    "percentPlaceholder": "10.00",
    "fixedPlaceholder": "5.00",
    "percentageExample": "Ex: 10%",
    "fixedExample": "Ex: R$ 5",
    "unlimitedPlaceholder": "Ilimitado",
    "deleteConfirm": "Tem certeza que deseja excluir o cupom \"{code}\"?"
  },
  "announcements": {
    "inboxTitle": "Avisos",
    "inboxSubtitle": "Comunicados e avisos publicados pela administração",
    "manageTitle": "Gerenciar Avisos",
    "manageSubtitle": "Publique avisos para revendedores e sub-revendedores",
    "new": "Novo Aviso",
    "createTitle": "Criar Aviso",
    "editTitle": "Editar Aviso",
    "pinned": "Fixado",
    "draft": "Rascunho",
    "inactive": "Inativo",
    "notPublished": "Não publicado",
    "markAllRead": "Marcar todos como lidos",
    "markAllSuccess": "Todos os avisos foram marcados como lidos",
    "unreadBanner": "Você tem {count} aviso(s) não lido(s)",
    "readCount": "{count} leitura(s)",
    "publishedAt": "Publicado em {date}",
    "emptyTitle": "Nenhum aviso",
    "emptyInboxHint": "Quando houver avisos, eles aparecerão aqui",
    "emptyManageHint": "Crie o primeiro aviso para seus revendedores",
    "deleteTitle": "Excluir aviso",
    "deleteMessage": "Deseja excluir o aviso \"{title}\"?",
    "deleteSuccess": "Aviso removido com sucesso",
    "saveSuccess": "Aviso salvo com sucesso",
    "form": {
      "title": "Título",
      "body": "Conteúdo",
      "audience": "Público-alvo",
      "priority": "Prioridade",
      "expiresAt": "Expira em",
      "expiresAtHint": "Opcional. Deixe em branco para aviso sem expiração.",
      "pinned": "Fixar no topo",
      "active": "Ativo",
      "publishNow": "Publicar agora",
      "unpublish": "Despublicar (voltar para rascunho)"
    },
    "audience": {
      "all_resellers": "Todos os revendedores",
      "resellers": "Apenas revendedores",
      "sub_resellers": "Apenas sub-revendedores"
    },
    "priority": {
      "normal": "Normal",
      "important": "Importante",
      "urgent": "Urgente"
    },
    "editor": {
      "placeholder": "Digite o conteúdo do aviso...",
      "toolbarLabel": "Formatação do texto",
      "bold": "Negrito",
      "italic": "Itálico",
      "underline": "Sublinhado",
      "bulletList": "Lista com marcadores",
      "numberedList": "Lista numerada",
      "heading": "Subtítulo",
      "paragraph": "Parágrafo normal",
      "link": "Inserir link",
      "linkPrompt": "URL do link (https://...)",
      "linkTextPrompt": "Texto do link (como aparecerá)",
      "help": "Selecione o texto e use os botões acima. Enter cria novo parágrafo; listas e links funcionam no texto selecionado."
    },
    "errors": {
      "load": "Erro ao carregar avisos",
      "save": "Erro ao salvar aviso",
      "delete": "Erro ao excluir aviso",
      "markRead": "Erro ao marcar avisos como lidos",
      "emptyBody": "Digite o conteúdo do aviso antes de salvar"
    }
  },
  "notifications": {
    "title": "Notificações",
    "empty": "Nenhuma notificação",
    "unreadTitle": "{count} notificação(ões) não lida(s)",
    "markAllRead": "Marcar como lidas",
    "clearAll": "Limpar todas",
    "remove": "Remover notificação",
    "expiration": {
      "accountExpiringTitle": "Conta expirando em breve",
      "accountExpiringMessage": "A conta {username} expira em {days} dia(s) ({expiresAt}).",
      "accountExpiredTitle": "Conta expirada",
      "accountExpiredMessage": "A conta {username} expirou em {expiresAt} e foi desativada.",
      "resellerExpiringTitle": "Assinatura expirando em breve",
      "resellerExpiringMessage": "O revendedor {username} expira em {days} dia(s) ({expiresAt}).",
      "resellerExpiredTitle": "Assinatura expirada",
      "resellerExpiredMessage": "O revendedor {username} expirou em {expiresAt} e foi desativado."
    },
    "announcement": {
      "newTitle": "Novo aviso: {title}",
      "newMessage": "Toque para ler o comunicado completo."
    }
  },
  "backupJobProgress": {
    "processing": "Processando...",
    "doNotClose": "Isso pode levar alguns minutos. Não feche esta janela.",
    "completed": "Concluído com sucesso!",
    "fileInfo": "Arquivo: {filename} ({size} MB)",
    "errorPrefix": "Erro:",
    "failed": "Falha no processamento",
    "pending": "Aguardando processamento..."
  },
  "install": {
    "subtitle": "Assistente de Instalação",
    "toggle_theme": "Alternar tema claro/escuro",
    "lang_change_later": "Você pode alterar o idioma depois nas configurações",
    "step_language": "Idioma",
    "step_language_desc": "Selecione o idioma do painel",
    "step_requirements": "Requisitos",
    "step_requirements_desc": "Verificação dos requisitos do sistema",
    "step_database": "Banco de Dados",
    "step_database_desc": "Configure a conexão com o MySQL",
    "step_admin": "Administrador",
    "step_admin_desc": "Crie a conta de administrador",
    "step_install": "Instalação",
    "step_install_desc": "Execução da instalação do sistema",
    "step_of": "Passo {current} de {total}",
    "req_api": "API Backend Acessível",
    "db_host": "Host do Banco",
    "db_user": "Usuário do Banco",
    "db_password": "Senha do Banco",
    "db_name": "Nome do Banco",
    "test_connection": "Testar Conexão",
    "testing": "Testando...",
    "connection_error": "Erro ao conectar no banco de dados",
    "admin_user": "Usuário Admin",
    "admin_email": "E-mail Admin",
    "admin_password": "Senha Admin",
    "admin_confirm": "Confirmar Senha",
    "passwords_mismatch": "As senhas não coincidem",
    "back": "Voltar",
    "next": "Próximo",
    "install_now": "Instalar Agora",
    "processing": "Processando...",
    "progress": "Progresso",
    "log_starting": "Iniciando instalação...",
    "log_connecting": "Conectando ao banco de dados...",
    "log_schemas": "Executando schemas do banco...",
    "log_done": "Instalação concluída com sucesso!",
    "log_error": "Erro durante a instalação",
    "success_title": "Instalação Concluída!",
    "success_message": "O sistema foi instalado com sucesso. Você já pode fazer login.",
    "go_to_login": "Ir para o Login",
    "retry": "Tentar Novamente"
  },
  "validation": {
    "required": "Este campo é obrigatório",
    "email": "Digite um e-mail válido",
    "minLength": "Deve ter pelo menos {min} caracteres",
    "maxLength": "Deve ter no máximo {max} caracteres",
    "min": "Deve ser maior ou igual a {min}",
    "max": "Deve ser menor ou igual a {max}",
    "alphanumeric": "Deve conter apenas letras e números",
    "numeric": "Deve conter apenas números",
    "url": "Digite uma URL válida",
    "ip": "Digite um IP válido",
    "port": "Digite uma porta válida (1-65535)",
    "passwordStrength": "A senha deve conter letras maiúsculas, minúsculas, números e caracteres especiais",
    "passwordMatch": "As senhas não coincidem",
    "unique": "Este valor já está em uso",
    "dateFormat": "Formato de data inválido",
    "futureDate": "A data deve ser futura",
    "pastDate": "A data deve ser passada"
  },
  "errors": {
    "generic": "Ocorreu um erro inesperado",
    "networkError": "Erro de conexão com o servidor",
    "serverError": "Erro interno do servidor",
    "notFound": "Recurso não encontrado",
    "unauthorized": "Você não tem permissão para acessar este recurso",
    "forbidden": "Acesso negado",
    "badRequest": "Requisição inválida",
    "timeout": "A requisição demorou muito tempo",
    "tooManyRequests": "Muitas requisições. Aguarde um momento.",
    "maintenance": "Sistema em manutenção. Tente novamente mais tarde.",
    "tryAgain": "Tente novamente",
    "contactSupport": "Se o problema persistir, entre em contato com o suporte"
  },
  "success": {
    "operationSuccess": "Operação realizada com sucesso",
    "created": "Criado com sucesso",
    "updated": "Atualizado com sucesso",
    "deleted": "Excluído com sucesso",
    "saved": "Salvo com sucesso",
    "copied": "Copiado para a área de transferência",
    "sent": "Enviado com sucesso",
    "uploaded": "Upload realizado com sucesso",
    "downloaded": "Download realizado com sucesso",
    "imported": "Importado com sucesso",
    "exported": "Exportado com sucesso"
  },
  "license": {
    "invalid": {
      "page_title": "Licença indisponível",
      "title": "Licença Inválida ou Expirada",
      "subtitle": "Este painel precisa de uma licença válida para continuar em operação",
      "error_occurred": "Erro na Validação de Licença",
      "default_error_title": "Acesso negado",
      "default_error_message": "Sua licença está inválida, expirada ou este domínio não está autorizado a usar o {panelName}.",
      "domain_info": "Informações do domínio",
      "current_domain": "Domínio atual",
      "status": "Status da licença",
      "status_invalid": "Inválida",
      "reason_code": "Código do motivo",
      "what_to_do": "O que fazer?",
      "step_1": "Entre em contato com o fornecedor do sistema ou suporte técnico",
      "step_2": "Informe o domínio atual para que sua licença seja ativada ou renovada",
      "step_3": "Após a correção, use «Verificar licença novamente» ou recarregue o painel",
      "contact_support": "Falar com suporte",
      "recheck": "Verificar licença novamente",
      "checking": "Verificando...",
      "recheck_success": "Licença validada! Redirecionando para o painel...",
      "recheck_still_invalid": "A licença ainda não está válida. Confirme com o suporte e tente novamente.",
      "recheck_failed": "Não foi possível verificar agora. Tente novamente em instantes.",
      "managed_externally": "Licenças gerenciadas externamente"
    },
    "status": {
      "expired": {
        "title": "Licença expirada",
        "message": "A licença deste domínio expirou. Renove para voltar a usar o {panelName}.",
        "badge": "Expirada",
        "hint": "Peça a renovação informando o domínio atual."
      },
      "suspended": {
        "title": "Licença suspensa",
        "message": "Esta licença foi suspensa pelo administrador da plataforma.",
        "badge": "Suspensa",
        "hint": "Entre em contato com o suporte para regularizar a situação."
      },
      "draft": {
        "title": "Licença não ativada",
        "message": "A licença ainda está em rascunho e não foi liberada para uso.",
        "badge": "Rascunho",
        "hint": "Aguarde a ativação oficial da licença neste domínio."
      },
      "not_found": {
        "title": "Licença não encontrada",
        "message": "Não encontramos uma licença válida associada a esta instalação.",
        "badge": "Não encontrada",
        "hint": "Confirme se a chave LICENSE_KEY está correta no servidor."
      },
      "domain_mismatch": {
        "title": "Domínio não autorizado",
        "message": "Esta licença está vinculada a outro domínio e não pode ser usada aqui.",
        "badge": "Domínio incorreto",
        "hint": "Solicite a migração da licença para o domínio atual."
      },
      "missing_license_key": {
        "title": "Chave de licença ausente",
        "message": "O servidor não possui LICENSE_KEY configurada para validar o painel.",
        "badge": "Sem chave",
        "hint": "Configure LICENSE_KEY no arquivo .env do backend."
      },
      "grace_period_expired": {
        "title": "Validação offline expirada",
        "message": "O período de uso offline acabou. Reconecte o servidor à internet para revalidar a licença.",
        "badge": "Offline expirado",
        "hint": "Verifique conectividade com o servidor de licenças."
      },
      "connection_error": {
        "title": "Falha na conexão",
        "message": "Não foi possível contactar o servidor de licenças neste momento.",
        "badge": "Sem conexão",
        "hint": "Confirme internet, firewall e LICENSE_SERVER_URL."
      },
      "validation_failed": {
        "title": "Falha na validação",
        "message": "A validação da licença falhou e o painel foi bloqueado por segurança.",
        "badge": "Validação falhou",
        "hint": "Revise LICENSE_KEY, domínio e logs do servidor."
      },
      "critical_error": {
        "title": "Erro crítico de licença",
        "message": "Ocorreu um erro interno ao validar a licença.",
        "badge": "Erro crítico",
        "hint": "Consulte os logs do backend e entre em contato com o suporte."
      },
      "unknown": {
        "title": "Licença não liberada",
        "message": "A licença não pôde ser confirmada para este domínio.",
        "badge": "Indefinido",
        "hint": "Informe o código do motivo ao suporte."
      },
      "invalid": {
        "title": "Licença inválida",
        "message": "A licença deste domínio não está válida para usar o {panelName}.",
        "badge": "Inválida",
        "hint": "Solicite ativação ou renovação informando o domínio atual."
      }
    }
  },
  "branding": {
    "title": "Branding e Personalização",
    "description": "Gerencie logos, ícones, favicon e aparência visual do painel",
    "tabs": {
      "logos": "Logos",
      "icons": "Ícones e Favicon",
      "pwa": "PWA e Redes Sociais"
    },
    "upload": "Fazer Upload",
    "replace": "Substituir",
    "remove": "Remover",
    "previewDefault": "Ver Padrão",
    "customBadge": "Custom",
    "defaultBadge": "Padrão",
    "uploading": "Enviando...",
    "formats": "Formatos",
    "maxSize": "Máx",
    "maxSourceSize": "Foto até {max} MB (recorte e compressão automáticos)",
    "filePath": "Arquivo",
    "showDefault": "Ver Padrão",
    "showCustom": "Ver Custom",
    "fileTooLarge": "Arquivo muito grande!\n\nTamanho: {size} MB\nMáximo: {max} MB\n\nCompacte a imagem antes de enviar.",
    "logosAndIconsDesc": "Personalize a identidade visual do seu painel",
    "recommendedSize": "Tamanho recomendado",
    "recommended": "Recomendado",
    "pwaSettings": "Configurações PWA",
    "pwaName": "Nome Completo da Aplicação",
    "pwaShortName": "Nome Curto (máx 12 caracteres)",
    "pwaDescription": "Descrição da Aplicação",
    "themeColor": "Cor do Tema",
    "dashboardLogo": "Logo do Dashboard",
    "loginLogo": "Logo da Tela de Login",
    "panelLogo": "Logo Geral do Painel",
    "faviconSvg": "Favicon SVG",
    "faviconPng": "Favicon PNG",
    "appleTouchIcon": "Apple Touch Icon",
    "appIcon192": "Ícone PWA 192x192",
    "appIcon512": "Ícone PWA 512x512",
    "ogImage": "Imagem Open Graph",
    "previewTitle": "Prévia do Upload",
    "sizeError": "Tamanho inválido!",
    "minSize": "Tamanho mínimo: {width}×{height}px",
    "sizeOk": "✓ Tamanho adequado",
    "confirmUpload": "Confirmar Upload",
    "invalidImage": "Arquivo de imagem inválido",
    "readError": "Erro ao ler arquivo",
    "dashboardLogoDesc": "Exibido na sidebar e header do painel admin",
    "loginLogoDesc": "Exibido na tela de login do sistema",
    "panelLogoDesc": "Logo principal usado em emails, documentos, etc",
    "faviconSvgDesc": "Ícone da aba do navegador - formato vetorial (recomendado)",
    "faviconPngDesc": "Fallback para navegadores que não suportam SVG",
    "appleTouchIconDesc": "Ícone para quando adicionar à tela inicial do iOS",
    "appIcon192Desc": "Ícone da aplicação PWA para Android/Chrome",
    "appIcon512Desc": "Ícone HD para splash screen e instalação",
    "ogImageDesc": "Imagem para compartilhamento em redes sociais (Facebook, Twitter, WhatsApp)"
  },
  "settingsPage": {
    "title": "Configurações do Painel",
    "description": "Personalize aparência, segurança e comportamento do sistema",
    "tabs": {
      "branding": "Branding",
      "security": "Segurança",
      "backup": "Backup",
      "cleanup": "Limpeza",
      "advanced": "Avançado",
      "templates": "Mensagens"
    },
    "branding": {
      "panelInfo": "Informações do Painel",
      "panelName": "Nome do Painel",
      "panelNamePlaceholder": "Ex: Meu Painel",
      "pwaShortName": "Nome Curto PWA",
      "pwaShortNamePlaceholder": "Ex: MeuPanel",
      "max12chars": "Máximo 12 caracteres",
      "description": "Descrição",
      "descriptionPlaceholder": "Descreva seu painel...",
      "logosAndIcons": "Logos e Ícones",
      "dashboardLogo": "Logo do Dashboard",
      "dashboardLogoDesc": "Exibido na sidebar e header",
      "loginLogo": "Logo de Login",
      "loginLogoDesc": "Exibido na tela de login",
      "favicon": "Favicon",
      "faviconDesc": "Ícone da aba do navegador",
      "pwaIcon": "Ícone PWA 192",
      "pwaIconDesc": "Instalação mobile (192x192)",
      "pwaIcon512": "Ícone PWA 512",
      "pwaIcon512Desc": "Splash screen mobile (512x512)",
      "appleIcon": "Apple Touch Icon",
      "appleIconDesc": "iOS home screen (180x180)",
      "ogImage": "Open Graph",
      "ogImageDesc": "Compartilhamento social",
      "colors": "Cores do Tema",
      "primaryColor": "Cor Primária",
      "secondaryColor": "Cor Secundária"
    },
    "security": {
      "title": "Segurança",
      "maxLoginAttempts": "Tentativas Máximas de Login",
      "attemptsRange": "Entre 3 e 10 tentativas",
      "sessionTimeout": "Timeout de Sessão (minutos)",
      "timeoutRange": "Entre 30 e 1440 minutos (24h)",
      "resellerMaxTestHours": "Limite de Teste (Revendedores)",
      "hours": "horas",
      "resellerMaxTestHoursHelp": "Tempo máximo em horas (1-72). Admin não tem limite.",
      "resellerLimitInfo": "ℹ️ Controle de Contas de Teste",
      "resellerLimitInfo1": "Revendedores podem criar testes de até {hours} horas",
      "resellerLimitInfo2": "Admin e Super Admin não têm limite (até 72h)",
      "resellerLimitInfo3": "Configuração aplicada imediatamente após salvar",
      "publicTestsTitle": "Testes Públicos",
      "publicTestsGloballyEnabled": "Habilitar testes públicos no painel",
      "publicTestsGloballyEnabledHelp": "Permite que vendedores ativem a página pública de testes gratuitos.",
      "publicTestDurationHours": "Duração do teste público",
      "publicTestCooldownHours": "Cooldown por contato",
      "publicTestCooldownHelp": "O mesmo e-mail só pode gerar novo teste após este período (global).",
      "publicTestIncludeV2ray": "Oferecer opção V2Ray na página pública",
      "expirationTitle": "Notificações de expiração",
      "expirationNotifyEnabled": "Avisar no sininho (contas e revendedores)",
      "expirationNotifyEnabledHelp": "O worker envia alertas no sininho quando contas ou assinaturas estão perto de expirar ou já expiraram.",
      "expirationEmailEnabled": "Enviar também por e-mail",
      "expirationEmailEnabledHelp": "Requer SMTP configurado. O e-mail vai para o admin/revendedor responsável.",
      "expirationWarningDays": "Dias de antecedência",
      "expirationWarningDaysHelp": "Separe por vírgula (ex.: 7,3,1). O worker avisa nesses dias antes da expiração.",
      "expirationAccountEmailTemplate": "Template e-mail — conta",
      "expirationResellerEmailTemplate": "Template e-mail — revendedor",
      "expirationEmailVars": "Variáveis: {username}, {expires_at}, {days_remaining}, {state_message}, {renewal_line}, {panel_name}, {br}"
    },
    "backup": {
      "title": "Backup do Sistema",
      "automaticBackup": "Backup Automático",
      "enableBackup": "Habilitar Backup Automático",
      "enableBackupDesc": "Backup do banco será enviado via Telegram no intervalo configurado",
      "interval": "Intervalo (minutos)",
      "intervalDesc": "Cada quantos minutos fazer backup",
      "telegramBot": "Token do Bot Telegram",
      "telegramBotPlaceholder": "123456:ABC-DEF...",
      "telegramChat": "Chat ID do Telegram",
      "telegramChatPlaceholder": "-100123456789",
      "createNow": "Fazer Backup Agora",
      "creating": "Criando backup...",
      "confirmCreate": "Deseja criar um backup manual agora?\n\nO backup será salvo no servidor.",
      "createBackupTitle": "Criar Backup Manual",
      "createSuccess": "Backup criado com sucesso!",
      "createError": "Erro ao criar backup",
      "restoreBackup": "Restaurar Backup",
      "selectFile": "Selecione o arquivo de backup",
      "dragFile": "Arraste o arquivo aqui ou clique para selecionar",
      "acceptedFormats": "Formatos aceitos: .enc, .sql",
      "invalidFile": "Arquivo inválido. Use apenas .enc ou .sql",
      "decryptPassword": "Senha de Descriptografia",
      "decryptPasswordPlaceholder": "Digite a senha do backup",
      "decryptPasswordHelp": "A mesma senha usada na criptografia do backup",
      "noPasswordForSql": "Arquivos .sql não exigem senha (ex.: importação de outro painel ou backup sem criptografia).",
      "confirmRestore": "Eu confirmo que desejo APAGAR todos os dados atuais.",
      "confirmRestoreDesc": "Esta ação não pode ser desfeita.",
      "confirmRestoreFinal": "ÚLTIMA CONFIRMAÇÃO\n\nTodos os dados atuais serão PERMANENTEMENTE APAGADOS.\n\nDeseja realmente continuar?",
      "restoreWarning": "⚠️ Confirmar Restauração",
      "restore": "Restaurar Backup",
      "restoring": "Restaurando...",
      "restoreSuccess": "Backup restaurado com sucesso! Você será desconectado.",
      "restoreError": "Erro ao restaurar backup",
      "importExternalSuccess": "Backup PAINEL-WEB-PRO importado (dados mesclados ao painel atual).",
      "importDragonAtlasSuccess": "Backup Dragon/Atlas importado (dados mesclados ao painel atual).",
      "importStatsCategories": "Categorias",
      "importStatsServers": "Servidores",
      "importStatsAdmins": "Contas admin/revenda (novas)",
      "importStatsAdminsMapped": "Logins admin do backup → admin Veltrix",
      "importStatsResellers": "Revendedores",
      "importStatsUsers": "Usuários SSH (novos)",
      "importStatsUsersRelinked": "SSH com dono atualizado (revenda/admin)",
      "importStatsUsersAdminSsh": "SSH do admin do backup (byid=1)",
      "importStatsSkipped": "Ignorados (já existiam)",
      "importStatsMapped": "Contas mapeadas (admin/revenda)",
      "importStatsParsed": "Lidos do arquivo",
      "encryptionPassword": "Senha de Criptografia",
      "encryptionPasswordPlaceholder": "Digite a senha para criptografar os backups (mínimo 8 caracteres)",
      "encryptionPasswordHelp": "Senha usada para criptografar os arquivos de backup. Guarde com segurança! Será necessária para restaurar o backup.",
      "criticalOperationTitle": "⚠️ OPERAÇÃO CRÍTICA",
      "criticalOperationItem1": "Esta operação APAGARÁ todos os dados atuais",
      "criticalOperationItem2": "Faça um backup antes de restaurar",
      "criticalOperationItem3": "Você será desconectado após a restauração",
      "restoreProgressWait": "Aguarde. Esta operação pode levar alguns minutos. Não feche esta página."
    },
    "cleanup": {
      "title": "Limpeza Automática",
      "enableCleanup": "Habilitar Limpeza de Dispositivos",
      "enableCleanupDesc": "Remove dispositivos inativos automaticamente",
      "minutes": "Inatividade (minutos)",
      "minutesDesc": "Remover após quantos minutos sem acesso"
    },
    "advanced": {
      "title": "Avançado",
      "maintenanceMode": "Modo Manutenção",
      "maintenanceModeDesc": "Desabilita acesso ao painel (apenas super admin)",
      "autoSales": "Vendas Automáticas Globais",
      "autoSalesDesc": "Habilita vendas automáticas para todos os admins"
    },
    "templates": {
      "title": "Templates de Mensagens",
      "description": "Personalize as mensagens exibidas após criar contas, revendedores, testes e vendas automáticas. Use as variáveis para dados dinâmicos e {br} para quebra de linha entre blocos.",
      "accountLabel": "Mensagem de Conta",
      "resellerLabel": "Mensagem de Revendedor",
      "testLabel": "Mensagem de Conta Teste",
      "whatsappFormat": "Formato WhatsApp",
      "telegramFormat": "Formato Telegram",
      "salesSectionTitle": "Vendas automáticas (página pública)",
      "salesSectionDesc": "Um único template por tipo — usado no botão «Copiar credenciais» após o pagamento PIX.",
      "salesAccountLabel": "Mensagem de conta (vendas)",
      "salesResellerLabel": "Mensagem de revenda (vendas)",
      "salesAccountRenewalLabel": "Renovação de conta (vendas)",
      "salesResellerRenewalLabel": "Renovação de revenda (vendas)",
      "salesResellerCreditsLabel": "Compra de créditos (vendas)",
      "availableVars": "Variáveis disponíveis (clique para inserir):",
      "formattingVarsHint": "Use {br} para uma linha em branco entre blocos. Linhas vazias no editor também funcionam. Campos vazios (Loja, App, etc.) são omitidos automaticamente.",
      "resetDefault": "Restaurar padrão",
      "preview": "Pré-visualização",
      "previewWhatsapp": "Preview WhatsApp",
      "previewTelegram": "Preview Telegram",
      "previewPlain": "Pré-visualização (texto simples)",
      "appLinkLabel": "Link do app",
      "appLinkHint": "Usado em {app_link} em todos os templates. Se vazio, a linha do app é omitida nas mensagens.",
      "appLinkPlaceholder": "https://play.google.com/store/apps/details?id=...",
      "customizedBadge": "Personalizado",
      "inheritedFromMaster": "Herdado de {name}",
      "inheritedFromGlobal": "Herdado do painel global",
      "clearCustomization": "Limpar personalização",
      "clearCustomizationSuccess": "Personalização removida — herdando do master novamente.",
      "clearCustomizationLocal": "Alterações locais descartadas — valor herdado restaurado.",
      "editorHint": "O texto padrão já vem preenchido para você editar. Use «Restaurar padrão» para voltar ao modelo original do sistema."
    },
    "unsavedChanges": "Você tem alterações não salvas",
    "saveSuccess": "Configurações salvas com sucesso!",
    "saveError": "Erro ao salvar configurações",
    "changesDiscarded": "Alterações descartadas",
    "uploadSuccess": "Arquivo enviado com sucesso!",
    "uploadError": "Erro ao enviar arquivo",
    "removeIcon": "Remover Ícone",
    "removeIconConfirm": "Tem certeza? O ícone padrão será usado.",
    "removeSuccess": "Ícone removido com sucesso"
  },
  "messageTemplates": {
    "copyWhatsapp": "Copiar (WhatsApp)",
    "copyTelegram": "Copiar (Telegram)",
    "copied": "Copiado!",
    "copySuccess": "Mensagem copiada!",
    "copyError": "Erro ao copiar",
    "emptyTemplate": "Configure o template em Configurações → Mensagens."
  },
  "pwa": {
    "installTitle": "Instalar App",
    "manualInstallToastTitle": "Instalação manual",
    "manualInstallToast": "Menu do navegador (⋮) → Instalar / Aplicativo / Instalar esta página.",
    "manualInstallHint": "Sem diálogo automático: no Chrome ou Edge use o menu (⋮), depois Instalar ou «Instalar como aplicação» / «Instalar esta página». Outros navegadores podem estar no menu lateral ou «Partilhar».",
    "httpsHint": "Em desktop é necessário HTTPS em produção (localhost é exceção).",
    "installMessage": "Instale o Veltrix Panel como aplicativo",
    "installButton": "Instalar Agora",
    "installing": "Instalando...",
    "benefit1": "Acesso rápido sem abrir navegador",
    "benefit2": "Funciona offline",
    "benefit3": "Notificações em tempo real",
    "updateTitle": "Atualização disponível",
    "updateMessage": "Uma nova versão está pronta para ser instalada",
    "updateButton": "Atualizar Agora"
  },
  "auditUserTypes": {
    "super_admin": "Super Admin",
    "admin": "Admin",
    "reseller": "Revendedor",
    "sub_reseller": "Sub-revendedor",
    "system": "Sistema",
    "info": "Info",
    "warning": "Aviso",
    "error": "Erro",
    "critical": "Crítico"
  },
  "auditEntities": {
    "users": "Conta",
    "resellers": "Revendedor",
    "categories": "Categoria",
    "servers": "Servidor",
    "payments": "Pagamento",
    "panel_settings": "Configuração",
    "admin_users": "Administrador",
    "device_ids": "Dispositivos",
    "system": "Sistema"
  },
  "auditActions": {
    "payment_created": "Pagamento criado",
    "setting_updated": "Configuração atualizada",
    "settings_bulk_updated": "Configurações em lote",
    "server_created": "Servidor criado",
    "server_updated": "Servidor atualizado",
    "server_deleted": "Servidor removido",
    "automation_toggled": "Automação alternada",
    "reseller_created": "Revendedor criado",
    "reseller_updated": "Revendedor atualizado",
    "reseller_deleted": "Revendedor removido",
    "reseller_credits_returned": "Créditos devolvidos",
    "reseller_credits_added": "Créditos adicionados",
    "reseller_credits_deducted": "Créditos deduzidos",
    "reseller_credit_deducted": "Crédito descontado (pagamento)",
    "reseller_slots_returned": "Slots devolvidos",
    "reseller_subscription_renewed": "Assinatura renovada",
    "reseller_hierarchy_deactivated": "Hierarquia desativada",
    "reseller_hierarchy_activated": "Hierarquia reativada",
    "reseller_created_via_payment": "Revenda via pagamento",
    "reseller_renewed_via_payment": "Renovação via pagamento",
    "reseller_credits_purchased": "Créditos comprados",
    "account_created": "Conta criada",
    "account_created_from_plan": "Conta via plano",
    "account_updated": "Conta atualizada",
    "account_deleted": "Conta removida",
    "account_renewed": "Conta renovada",
    "account_status_toggled": "Status da conta",
    "category_created": "Categoria criada",
    "category_updated": "Categoria atualizada",
    "category_deleted": "Categoria removida",
    "category_set_default": "Categoria padrão",
    "category_migration": "Migração de categorias",
    "branding_updated": "Branding atualizado",
    "branding_deleted": "Branding removido",
    "branding_settings_updated": "Branding (configurações)",
    "devices_cleanup": "Limpeza de dispositivos",
    "admin_login": "Login",
    "admin_logout": "Logout",
    "admin_created": "Admin criado",
    "failed_login_attempt": "Login falhou",
    "worker_backup_success": "Backup automático",
    "worker_backup_error": "Backup automático (erro)",
    "worker_device_cleanup": "Limpeza de dispositivos",
    "worker_device_cleanup_error": "Limpeza de dispositivos (erro)",
    "worker_audit_log_cleanup": "Limpeza de logs de auditoria",
    "worker_audit_log_cleanup_error": "Limpeza de logs (erro)",
    "worker_check_expired": "Verificação de expirados",
    "worker_check_expired_error": "Verificação de expirados (erro)"
  },
  "auditMessages": {
    "genericWithEntity": "{action} — {entity}",
    "payment_created": "Pagamento #{entityId} registrado",
    "setting_updated": "Configuração do painel alterada",
    "settings_bulk_updated": "Várias configurações atualizadas",
    "server_created": "Servidor #{entityId} criado",
    "server_updated": "Servidor #{entityId} atualizado",
    "server_deleted": "Servidor #{entityId} removido",
    "automation_toggled": "Estado da automação alterado",
    "reseller_created": "Revendedor #{entityId} criado",
    "reseller_updated": "Revendedor #{entityId} atualizado",
    "reseller_deleted": "Revendedor #{entityId} removido",
    "reseller_credits_returned": "{credits_returned} crédito(s) devolvido(s) ao revendedor pai",
    "reseller_credits_added": "+{amount} crédito(s); saldo: {new_balance}",
    "reseller_credits_deducted": "Créditos deduzidos do revendedor #{entityId}",
    "reseller_credit_deducted": "Desconto de R$ {amount} — {detail}",
    "reseller_slots_returned": "{slots_returned} slot(s) devolvido(s)",
    "reseller_subscription_renewed": "Assinatura do revendedor #{entityId} renovada",
    "reseller_hierarchy_deactivated": "Revendedor #{entityId} e sub-rede desativados",
    "reseller_hierarchy_activated": "Revendedor #{entityId} e sub-rede reativados",
    "reseller_created_via_payment": "Sub-revendedor {username} criado via PIX (tipo: {type})",
    "reseller_renewed_via_payment": "Revendedor #{resellerId} renovado (+{days} dias, limite {limit})",
    "reseller_credits_purchased": "Revendedor #{resellerId}: +{credits} crédito(s); saldo {balance}",
    "account_created": "Conta {username} criada",
    "account_created_from_plan": "Conta criada a partir de plano (ID {entityId})",
    "account_updated": "Conta #{entityId} atualizada",
    "account_deleted": "Conta #{entityId} removida",
    "account_renewed": "Conta #{entityId} renovada",
    "account_status_toggled": "Status da conta #{entityId} alterado",
    "category_created": "Categoria criada (ID {entityId})",
    "category_updated": "Categoria #{entityId} atualizada",
    "category_deleted": "Categoria #{entityId} removida",
    "category_set_default": "Categoria #{entityId} definida como padrão",
    "category_migration": "Contas migradas entre categorias",
    "branding_updated": "Ícone ou imagem de branding atualizado",
    "branding_deleted": "Item de branding removido (tipo: {type})",
    "branding_settings_updated": "Configurações de branding salvas",
    "devices_cleanup": "{count} dispositivo(s) removido(s) na limpeza manual",
    "admin_login": "Sessão iniciada",
    "admin_logout": "Sessão encerrada",
    "admin_created": "Novo administrador (ID {entityId})",
    "failed_login_attempt": "Tentativa de login falhou para \"{username}\" (IP {ip})",
    "worker_check_expired": "{expired_accounts} conta(s) e {expired_resellers} revendedor(es) expirados; {slots_returned} slot(s) devolvido(s)",
    "worker_check_expired_error": "Falha na verificação de expirados: {error}",
    "worker_device_cleanup": "{devices_deleted} dispositivo(s) removido(s)",
    "worker_device_cleanup_error": "Falha na limpeza de dispositivos: {error}",
    "worker_audit_log_cleanup": "{logs_deleted} log(s) removido(s) (retenção: {retention_days} dias)",
    "worker_audit_log_cleanup_error": "Falha na limpeza de logs: {error}",
    "worker_backup_success": "Backup {filename} concluído ({size_mb} MB)",
    "worker_backup_error": "Falha no backup automático: {error}"
  },
  "auditDetails": {
    "account_created_via_pix": "conta criada via pagamento PIX"
  },
  "viewMessages": {
    "profile": {
      "invalidFormat": "Formato inválido. Use JPG ou PNG",
      "fileTooLarge": "Arquivo muito grande. Máximo: {max} MB na seleção.",
      "imageTooLarge": "Imagem muito grande. Máximo: 512x512 pixels",
      "avatarUpdatedSuccess": "Avatar atualizado com sucesso!",
      "avatarRemovedSuccess": "Avatar removido com sucesso!",
      "uploadError": "Erro ao fazer upload",
      "removeAvatarError": "Erro ao remover avatar",
      "enterPassword": "Digite a nova senha!",
      "passwordMismatch": "As senhas não coincidem!",
      "passwordChangeSuccess": "Senha alterada com sucesso!",
      "enterCurrentPassword": "Digite sua senha atual para alterar a senha!",
      "confirmRemoveAvatar": "Tem certeza que deseja remover sua foto de perfil?",
      "updateProfileError": "Erro ao atualizar perfil"
    },
    "backup": {
      "configureTelegram": "Configure o bot Telegram e salve as configurações",
      "autoBackupDisabled": "Backup automático desativado",
      "enterBotToken": "Informe o Bot Token",
      "enterChatId": "Informe o Chat ID",
      "configureEncryptionPassword": "Configure uma senha de criptografia (mínimo 8 caracteres)",
      "encryptionPasswordTooShort": "A senha de criptografia deve ter no mínimo 8 caracteres",
      "configSavedSuccess": "Configurações de backup salvas com sucesso!",
      "configSaveError": "Erro ao salvar configurações de backup",
      "backupStarted": "Backup iniciado! Você receberá o arquivo no Telegram em instantes.",
      "backupError": "Erro ao executar backup",
      "selectValidEncFile": "Por favor, selecione um arquivo .enc válido",
      "restoreSuccess": "Backup restaurado com sucesso!\n\nVocê será desconectado. Faça login novamente.",
      "restoreError": "Erro ao restaurar backup",
      "confirmBackupTitle": "Executar Backup Agora?",
      "confirmBackupMessage": "Será gerado um backup completo do banco de dados e enviado para o Telegram configurado. Deseja continuar?",
      "confirmRestoreTitle": "⚠️ RESTAURAR BACKUP",
      "confirmRestoreMessage": "ATENÇÃO: Todos os dados atuais serão SUBSTITUÍDOS pelos dados do backup. Esta ação NÃO pode ser desfeita. Deseja continuar?",
      "passwordNotConfigured": "⚠️ Senha de backup não configurada!\n\nPor favor, configure a senha de criptografia acima e salve as configurações antes de fazer o backup.",
      "incompleteConfiguration": "❌ Configuração incompleta!\n\n{error}\n\nPor favor, verifique as configurações acima e tente novamente.",
      "noBackupRun": "Nenhum backup realizado",
      "confirmManualBackupTitle": "Confirmar Backup Manual",
      "confirmManualBackupMessage": "Deseja fazer um backup manual agora?\n\nO backup será criptografado e enviado para o Telegram."
    },
    "branding": {
      "loadingError": "Erro ao carregar configurações de branding",
      "iconUpdatedSuccess": "Ícone atualizado com sucesso!",
      "iconSizesGenerated": "{count} tamanhos gerados automaticamente!",
      "iconUploadError": "Erro ao fazer upload do ícone",
      "iconRemovedSuccess": "Ícone removido com sucesso!",
      "iconRemoveError": "Erro ao remover ícone",
      "pwaUpdatedSuccess": "Configurações PWA atualizadas!",
      "pwaUpdateError": "Erro ao atualizar configurações PWA"
    },
    "dashboard": {
      "statsLoadError": "Erro ao carregar estatísticas do dashboard",
      "categoriesLoadError": "Erro ao carregar categorias"
    },
    "accounts": {
      "loadError": "Erro ao carregar contas",
      "categoriesLoadError": "Erro ao carregar categorias",
      "statusUpdated": "Status atualizado!",
      "deleteSuccess": "Conta deletada com sucesso!",
      "bulkDeleteSuccess": "{deleted} de {total} conta(s) deletada(s) com sucesso!",
      "bulkDeleteNone": "Nenhuma conta foi deletada",
      "devicesRemovedSuccess": "Dispositivos removidos com sucesso!",
      "enterNewPassword": "Digite uma nova senha para atualizar",
      "updateSuccess": "Conta atualizada com sucesso!",
      "loadDetailsError": "Erro ao carregar detalhes da conta",
      "credentialsCopied": "Credenciais copiadas!",
      "expiredBeforeEnable": "Conta expirada! Renove antes de ativar.",
      "createError": "Erro ao criar conta",
      "selectPlanAndCategory": "Selecione um plano e uma categoria",
      "insufficientCreditsPlan": "Créditos insuficientes! Você tem {available}, precisa de {needed} para este plano ({days} dias)",
      "insufficientCreditsMonths": "Créditos insuficientes! Você tem {available}, precisa de {needed}",
      "renewSuccess": "Conta renovada com sucesso!",
      "renewError": "Erro ao renovar conta",
      "selectCategory": "Selecione uma categoria",
      "statusUpdateError": "Erro ao atualizar status",
      "deleteError": "Erro ao deletar conta",
      "bulkDeleteError": "Erro ao deletar algumas contas",
      "clearDevicesError": "Erro ao limpar dispositivos",
      "copyCredentialsError": "Erro ao copiar credenciais",
      "accountNotFound": "Conta não encontrada",
      "buildMessageError": "Não foi possível montar a mensagem",
      "createTestError": "Erro ao criar conta de teste",
      "minDaysError": "Validade mínima é {min} dias"
    },
    "accountPlans": {
      "loadError": "Erro ao carregar planos",
      "createSuccess": "Plano criado com sucesso!",
      "updateSuccess": "Plano atualizado com sucesso!",
      "deleteSuccess": "Plano deletado com sucesso!",
      "saveError": "Erro ao salvar plano",
      "deleteError": "Erro ao deletar plano"
    },
    "resellers": {
      "loadError": "Erro ao carregar revendedores",
      "creditsAddedSuccess": "Créditos adicionados com sucesso!",
      "subscriptionAdjustedSuccess": "Assinatura ajustada com sucesso!",
      "processError": "Erro ao processar operação",
      "deleteSuccess": "Revendedor excluído com sucesso!",
      "deleteError": "Erro ao excluir revendedor",
      "fillRequiredFields": "Preencha usuário, email e senha",
      "statusUpdated": "Status alterado!",
      "statusUpdateError": "Erro ao alterar status",
      "bulkDeleteSuccess": "{deleted} de {total} revendedor(es) excluído(s) com sucesso!",
      "bulkDeleteNone": "Nenhum revendedor foi excluído",
      "bulkDeleteError": "Erro ao excluir alguns revendedores"
    },
    "resellerPlans": {
      "loadError": "Erro ao carregar planos",
      "deleteSuccess": "Plano deletado com sucesso!",
      "deleteError": "Erro ao deletar plano"
    },
    "checkuser": {
      "statsLoadError": "Erro ao carregar estatísticas do CheckUser",
      "configSaved": "Configurações salvas com sucesso!",
      "urlCopied": "URL copiada!",
      "endpointResponding": "Endpoint {name} respondendo! ✅\n\n{details}",
      "endpointProblem": "Endpoint {name} com problema:\n\n{details}",
      "endpointTestError": "Erro ao testar endpoint: {error}",
      "devicesRemovedSuccess": "Dispositivos removidos com sucesso!",
      "cleanupManualSuccess": "Limpeza executada: {removed} dispositivo(s) removido(s).",
      "cleanupManualError": "Erro ao executar limpeza manual.",
      "configSaveError": "Erro ao guardar configurações.",
      "devicesClearError": "Erro ao limpar dispositivos."
    },
    "settings": {
      "loadError": "Erro ao carregar configurações"
    },
    "logs": {
      "loadError": "Erro ao carregar logs",
      "logsCleared": "{count} log(s) removido(s)!",
      "clearError": "Erro ao limpar logs"
    },
    "automations": {
      "selectPaymentMethodsWarning": "Selecione pelo menos um método de pagamento",
      "paymentMethodsUpdatedSuccess": "Métodos de pagamento atualizados com sucesso",
      "paymentMethodsSaveError": "Erro ao salvar métodos de pagamento",
      "urlCopied": "URL copiada!",
      "categorySaveError": "Erro ao salvar categoria",
      "featureDisabled": "Desativado",
      "featureEnabledWithUrl": "Ativado! URL: {url}",
      "updateError": "Erro ao atualizar",
      "goToAccountPlansTitle": "Ir para Planos de Conta?",
      "goToResellerPlansTitle": "Ir para Planos de Revenda?",
      "deleteGatewayConfirm": "Tem certeza que deseja remover este gateway?",
      "deleteGatewayTitle": "Remover Gateway",
      "gatewayRemoved": "Gateway removido!",
      "gatewayRemoveError": "Erro ao remover gateway",
      "gatewayUpdatedSuccess": "Gateway e métodos atualizados!",
      "gatewayAddedSuccess": "Gateway adicionado! Clique em \"Configurar Métodos\" para selecionar formas de pagamento.",
      "gatewaySaveError": "Erro ao salvar gateway"
    },
    "auth": {
      "loginFallbackError": "Erro ao fazer login. Verifique suas credenciais."
    },
    "payment": {
      "usernameValidation": "Usuário deve ter 3-32 caracteres (apenas letras e números)",
      "createPaymentError": "Erro ao criar pagamento. Tente novamente."
    },
    "servers": {
      "loadError": "Erro ao carregar servidores: {error}",
      "categoriesLoadWarning": "Não foi possível carregar categorias. Usando categoria padrão.",
      "createSuccess": "Servidor adicionado com sucesso!",
      "createError": "Erro ao adicionar servidor",
      "createErrorWithTips": "{message}\n\n💡 Dicas:\n{tips}",
      "invalidApiPort": "Porta da API inválida. Deve estar entre 1024 e 65535",
      "duplicateServer": "Já existe um servidor com este IP e porta",
      "updateSuccess": "Servidor atualizado com sucesso!",
      "updateError": "Erro ao atualizar servidor",
      "apiOnlineSuccess": "API está online e funcionando!",
      "apiNotResponding": "API não está respondendo",
      "apiNotInstalledInfo": "API não está instalada",
      "apiStatusCheckError": "Erro ao verificar status da API",
      "deleteSuccess": "Servidor excluído com sucesso!",
      "deleteError": "Erro ao excluir servidor",
      "apiUninstalledBeforeDelete": "API desinstalada antes da exclusão",
      "deleteContinueDespiteApiError": "Continuando exclusão mesmo com erro na desinstalação da API",
      "apiUninstallSuccess": "API desinstalada com sucesso!",
      "apiUninstallError": "Erro ao desinstalar API",
      "ssh2ExtensionError": "Extensão SSH2 não está instalada.\n\n{instructions}\n\n{note}",
      "unknownError": "Erro desconhecido"
    },
    "categories": {
      "loadError": "Erro ao carregar categorias",
      "createSuccess": "Categoria criada com sucesso",
      "updateSuccess": "Categoria atualizada com sucesso",
      "saveError": "Erro ao salvar categoria",
      "alreadyDefault": "Esta categoria já é a padrão",
      "setDefaultSuccess": "Categoria \"{name}\" definida como padrão!",
      "setDefaultError": "Erro ao definir categoria padrão",
      "migrateSuccess": "{count} {entity} migrados com sucesso!",
      "migrateError": "Erro ao migrar",
      "deleteSuccess": "Categoria deletada com sucesso"
    },
    "coupons": {
      "loadError": "Erro ao carregar cupons",
      "createSuccess": "Cupom criado!",
      "updateSuccess": "Cupom atualizado!",
      "saveError": "Erro ao salvar cupom",
      "deactivated": "Cupom desativado",
      "activated": "Cupom ativado",
      "toggleError": "Erro ao atualizar cupom",
      "deleteSuccess": "Cupom excluído!",
      "deleteError": "Erro ao excluir cupom"
    }
  },
  "apiMessages": {
    "emailPasswordRequired": "Usuário/email e senha são obrigatórios",
    "invalidCredentials": "Credenciais inválidas",
    "notAuthenticated": "Não autenticado",
    "invalidToken": "Token inválido",
    "resellerInactive": "Sua conta de revendedor está inativa. Entre em contato com o suporte.",
    "resellerExpired": "Sua assinatura de revendedor expirou. Renove para continuar.",
    "resellerNotFound": "Revendedor não encontrado",
    "loginSuccess": "Login realizado com sucesso",
    "logoutSuccess": "Logout realizado com sucesso",
    "currentPasswordRequired": "Senha atual é obrigatória",
    "newPasswordRequired": "Nova senha é obrigatória",
    "currentPasswordWrong": "Senha atual incorreta",
    "passwordChanged": "Senha alterada com sucesso",
    "noFileUploaded": "Nenhum arquivo enviado ou erro no upload",
    "fileTooLarge": "Arquivo muito grande. Máximo: 3MB após recorte",
    "fileTooLarge3mb": "Arquivo muito grande. Máximo: 3MB após recorte",
    "invalidFileType": "Tipo de arquivo inválido. Use JPG ou PNG",
    "imageProcessingError": "Erro ao processar imagem",
    "imageTooLarge": "Imagem muito grande. Máximo: 512x512 pixels",
    "avatarUpdated": "Avatar atualizado com sucesso",
    "avatarRemoved": "Avatar removido com sucesso",
    "accountCreated": "Conta criada com sucesso",
    "accountUpdated": "Conta atualizada com sucesso",
    "accountDeleted": "Conta deletada com sucesso",
    "accountRenewed": "Conta renovada com sucesso",
    "accountCreatedFromPlan": "Conta criada a partir do plano",
    "planCategoryRequired": "Campos plan_id e category_id são obrigatórios",
    "noValidIds": "Nenhum ID válido fornecido",
    "errorListingAccounts": "Erro ao listar contas",
    "errorUpdatingAccount": "Erro ao atualizar conta",
    "errorDeletingAccount": "Erro ao deletar conta",
    "planCreated": "Plano criado com sucesso",
    "planUpdated": "Plano atualizado com sucesso",
    "planDeleted": "Plano deletado com sucesso",
    "noPermissionEditPlan": "Você não tem permissão para editar este plano",
    "noPermissionDeletePlan": "Você não tem permissão para deletar este plano",
    "resellerNoCategory": "Revendedor não possui categoria vinculada",
    "errorFetchingData": "Erro ao buscar dados",
    "usernameInvalid": "Usuário deve ter 3-50 caracteres alfanuméricos",
    "emailInvalid": "Email inválido",
    "passwordTooShort": "Senha deve ter no mínimo 4 caracteres",
    "usernameExists": "Usuário já existe",
    "emailExists": "Email já cadastrado",
    "adminCreated": "Administrador criado com sucesso",
    "adminUpdated": "Administrador atualizado com sucesso",
    "adminDeleted": "Administrador deletado com sucesso",
    "cannotChangeSuperAdmin": "Não é possível alterar role de super_admin",
    "cannotDeleteSuperAdmin": "Não é possível deletar super_admin",
    "cannotDeleteSelf": "Não é possível deletar sua própria conta",
    "cannotDeactivateSelf": "Você não pode desativar sua própria conta",
    "cannotDeactivateSuperAdmin": "Não é possível desativar super_admin",
    "errorListingAdmins": "Erro ao listar administradores",
    "couponCodeRequired": "Código do cupom é obrigatório",
    "invalidDiscount": "Desconto inválido",
    "couponExists": "Cupom com este código já existe",
    "couponCreated": "Cupom criado com sucesso",
    "couponInvalid": "Cupom inválido ou expirado",
    "usernameRequired": "Usuário obrigatório",
    "usernameOrEmailExists": "Usuário ou email já existe",
    "serverCreated": "Servidor criado com sucesso",
    "serverUpdated": "Servidor atualizado com sucesso",
    "serverDeleted": "Servidor deletado com sucesso",
    "syncStarted": "Sincronização iniciada. Será notificado quando terminar.",
    "invalidServerId": "ID do servidor inválido",
    "userNotIdentified": "Utilizador não identificado",
    "serverNotFound": "Servidor não encontrado",
    "jobNotFound": "Tarefa não encontrada ou expirada",
    "jobIdRequired": "job_id é obrigatório",
    "categoryCreated": "Categoria criada com sucesso",
    "categoryUpdated": "Categoria atualizada com sucesso",
    "categoryDeleted": "Categoria deletada com sucesso",
    "settingsSaved": "Configurações salvas com sucesso",
    "backupSuccess": "Backup realizado com sucesso",
    "resellerCreated": "Revendedor criado com sucesso",
    "resellerUpdated": "Revendedor atualizado com sucesso",
    "resellerDeleted": "Revendedor deletado com sucesso",
    "testAccountCreated": "Conta de teste criada com sucesso",
    "subscriptionExpired": "Sua assinatura expirou. Renove para continuar.",
    "userNotFound": "Usuário não encontrado",
    "resellersOnly": "Apenas revendedores",
    "error": "Erro",
    "accountStatusIs": "Sua conta está com status irregular. Entre em contato com o suporte.",
    "resellerAccountStatusIs": "Sua conta de revendedor está com status irregular. Entre em contato com o suporte.",
    "resellerExpiredAt": "Sua assinatura de revendedor expirou. Renove para continuar criando contas.",
    "noCreditsAvailable": "Sem créditos disponíveis.",
    "loginLimitReached": "Limite de logins atingido.",
    "noServersInCategory": "Nenhum servidor encontrado na categoria selecionada.",
    "errorDeletingAccounts": "Erro ao deletar contas.",
    "loginError": "Erro no login.",
    "errorFetchingUser": "Erro ao buscar usuário.",
    "errorRenewingToken": "Erro ao renovar token.",
    "errorUpdatingProfile": "Erro ao atualizar perfil.",
    "errorListingPlans": "Erro ao listar planos.",
    "invalidIds": "IDs inválidos.",
    "creditResellerRestriction": "Revendedores tipo crédito possuem restrições de edição.",
    "enterNewPassword": "Digite uma nova senha ou WhatsApp para atualizar."
  },
  "publicTest": {
    "title": "Teste Grátis",
    "subtitle": "Gere seu teste de {hours}h gratuitamente",
    "unavailable": "Testes públicos não estão disponíveis no momento.",
    "loadError": "Não foi possível carregar a página de testes.",
    "invalidLink": "Link de teste inválido.",
    "emailLabel": "E-mail",
    "emailPlaceholder": "seu{'@'}gmail.com",
    "phoneLabel": "WhatsApp / Telegram",
    "phonePlaceholder": "(11) 99999-9999",
    "optional": "opcional",
    "contactHelp": "E-mail obrigatório de provedor conhecido (Gmail, Outlook, etc.). WhatsApp/Telegram são opcionais. Cooldown de {cooldown}h por e-mail. As credenciais são enviadas apenas por e-mail.",
    "emailRequired": "Informe um e-mail válido.",
    "emailNotTrusted": "Use um e-mail de provedor conhecido (Gmail, Outlook, Yahoo, iCloud, Proton, UOL…).",
    "contactRequired": "Informe um e-mail válido.",
    "includeV2ray": "Incluir acesso V2Ray",
    "generateButton": "Gerar teste grátis",
    "generating": "Gerando teste...",
    "createError": "Erro ao gerar teste. Tente novamente.",
    "cooldownActive": "Você já gerou um teste recentemente. Tente novamente em aproximadamente {hours}h.",
    "successTitle": "Teste gerado! Confira seu e-mail",
    "validForHours": "Válido por {hours} horas",
    "expiresAt": "Expira em",
    "copyError": "Não foi possível copiar automaticamente.",
    "shareMessage": "Mensagem para compartilhar",
    "copyShareMessage": "Copiar mensagem",
    "emailSentTo": "Enviamos as credenciais para {email}",
    "checkSpamHint": "Verifique a caixa de entrada e o spam. As credenciais não aparecem nesta página por segurança."
  },
  "publicApiDocs": {
    "title": "Documentação das APIs Públicas",
    "subtitle": "Endpoints para vendas, renovação, testes e recovery — sessão PWA no domínio licenciado ou token por vendedor",
    "authNote": "Rotas /api/public/* exigem cookie de sessão (PWA no domínio licenciado, com Origin válido) ou header X-Public-Api-Token (integrações server-side). Cada admin/revendedor possui um token próprio, válido apenas para o slug da sua conta. CheckUser e webhooks não usam este guard.",
    "authPwaTitle": "PWA (browser)",
    "authPwaDesc": "POST /api/public/session/bootstrap emite cookie HttpOnly. Requer licença válida no domínio e Origin/Referer coerente. Usado pelo frontend oficial.",
    "authTokenTitle": "Integração externa (Postman, bot, servidor)",
    "authTokenDesc": "Header X-Public-Api-Token gerado abaixo. Um token por conta (admin/revendedor). Em rotas com {slug}, o slug deve ser o da conta dona do token.",
    "tokenManagementTitle": "Seu token de API pública",
    "postmanVariablesHint": "Collection Postman: preencha a variável public_api_token após gerar o token. Use sales_slug com o slug da sua conta.",
    "sessionOrToken": "Sessão PWA (domínio licenciado) ou X-Public-Api-Token",
    "pwaBootstrapOnly": "Bootstrap PWA — isento do guard (exige licença + origem)",
    "noGuard": "Sem guard (CheckUser / webhooks)",
    "tokenOnly": "Somente X-Public-Api-Token — sessão PWA não aceita.",
    "baseUrl": "Base da API",
    "yourSlug": "Seu slug de vendas (exemplos com slug)",
    "copy": "Copiar",
    "copied": "Copiado!",
    "rateLimit": "Limite",
    "queryParams": "Query params",
    "requestBody": "Corpo da requisição (JSON)",
    "responseBody": "Resposta (JSON)",
    "queryHints": {
      "paymentMethodsAmount": "Filtra métodos cujo min_amount/max_amount cobre o valor (ex.: ?amount=29.90). Recomendado antes do checkout.",
      "renewalSellerId": "ID do vendedor retornado em POST /renewal/search (obrigatório)."
    },
    "examples": {
      "pix": "PIX (Brasil)",
      "creditCard": "Cartão — Mercado Pago BR",
      "creditCardAr": "Cartão — Mercado Pago AR (DNI)",
      "cashTicket": "Boleto/ticket cash (ex.: OXXO MX)",
      "pixCreated": "PIX criado (pending)",
      "cardApproved": "Cartão aprovado",
      "cardPending": "Cartão em análise",
      "cashCreated": "Ticket cash criado",
      "pending": "Status pending",
      "provisioning": "Aprovado — provisionando conta",
      "approvedAccount": "Aprovado — credenciais da conta"
    },
    "guides": {
      "paymentOverview": {
        "title": "Fluxo de pagamento",
        "intro": "Passos comuns para vendas de conta, revenda e renovação.",
        "bullet1": "GET payment-methods (com ?amount=) → escolha gateway_id e payment_method_type.",
        "bullet2": "PIX/cartão exigem customer_name (nome + sobrenome), customer_email e documento do pagador.",
        "bullet3": "POST payment → use payment_id retornado para polling em GET /payment/{paymentId}/status.",
        "bullet4": "Cartão aprovado pode retornar status approved na hora; a conta pode levar alguns segundos (provisioning: true).",
        "bullet5": "Tickets cash (OXXO, Rapipago…) retornam payment_url — redirecione o cliente para pagar offline."
      },
      "creditCardFlow": {
        "title": "Cartão de crédito (Mercado Pago)",
        "intro": "A tokenização do cartão é feita no cliente, direto na API do Mercado Pago — não envie número/CVV ao painel.",
        "bullet1": "Obtenha mp_public_key e mp_credential_environment em GET payment-methods → data.gateway.",
        "bullet2": "No checkout, carregue https://www.mercadopago.com/v2/security.js (view=checkout) e leia MP_DEVICE_SESSION_ID ou #deviceId — obrigatório em produção (APP_USR).",
        "bullet3": "No frontend, POST https://api.mercadopago.com/v1/card_tokens?public_key=... com Public Key + dados do cartão.",
        "bullet4": "Opcional: GET /v1/payment_methods/installments?public_key=&bin=&amount= para parcelas e issuer_id.",
        "bullet5": "Envie ao painel: card_token, mp_payment_method_id, installments e cardholder_name (nome impresso no cartão).",
        "bullet6": "Envie mp_device_session_id (antifraude) e mp_public_key_used (mesma Public Key da tokenização).",
        "bullet7": "issuer_id e issuer_verified são opcionais (retornados na consulta BIN/parcelas).",
        "bullet8": "Se rejected → success:false; se approved/in_process → poll GET /payment/{paymentId}/status até provisioning=false."
      },
      "payerDocuments": {
        "title": "Documento do pagador por região",
        "intro": "O campo customer_cpf aceita o documento local. Use identification_type quando diferente do padrão da região.",
        "bullet1": "BR → CPF (11 dígitos, type CPF). PIX só no Brasil.",
        "bullet2": "AR → DNI (7–8 dígitos). PE → DNI (8 dígitos).",
        "bullet3": "MX → CURP (18 caracteres alfanuméricos).",
        "bullet4": "CL → RUT (8–9 caracteres, inclui dígito verificador K).",
        "bullet5": "CO → CC (6–10 dígitos). UY → CI (6–8 dígitos).",
        "bullet6": "GET payment-methods retorna gateway.payer_document (type, min_len, max_len, charset) e payer_document_rules (payment ou customer por método).",
        "bullet7": "Asaas/EFI (BR): documento sempre CPF."
      }
    },
    "pages": {
      "accountSales": "Loja pública de contas",
      "resellerSales": "Loja pública de revenda",
      "renewal": "Renovação pública",
      "publicTest": "Testes públicos grátis",
      "credentialRecovery": "Recuperação de credenciais"
    },
    "sections": {
      "auth": {
        "title": "Autenticação",
        "description": "Bootstrap de sessão PWA e gestão de token por vendedor (integrações externas)."
      },
      "accountSales": {
        "title": "Vendas de contas",
        "description": "Planos, pagamento PIX/cartão e templates de mensagem por slug do vendedor."
      },
      "resellerSales": {
        "title": "Vendas de revenda",
        "description": "Planos de revenda, pagamento e validação de username/e-mail."
      },
      "renewal": {
        "title": "Renovação pública",
        "description": "Cliente busca conta por username/UUID e renova via pagamento."
      },
      "publicTest": {
        "title": "Testes públicos",
        "description": "Geração de teste grátis por e-mail (PWA/sessão) ou credenciais diretas no JSON (somente token do dono do slug)."
      },
      "credentialRecovery": {
        "title": "Recuperação de credenciais",
        "description": "Cliente informa o e-mail cadastrado e recebe todas as credenciais VPN vinculadas (usuário, senha, status e validade) em um único e-mail."
      },
      "payment": {
        "title": "Pagamento (compartilhado)",
        "description": "Polling de status (PIX, cartão e cash) e cancelamento de pagamentos pending."
      },
      "checkuser": {
        "title": "CheckUser",
        "description": "Integração com apps DTunnel e Conecta4G (rotas na raiz do painel)."
      }
    },
    "endpoints": {
      "auth": {
        "sessionBootstrap": {
          "description": "Inicia sessão pública (cookie HttpOnly) para o PWA. Body: context (sales, test, renewal…) e slug opcional.",
          "rateLimit": "30 req/min"
        }
      },
      "accountSales": {
        "salesPlans": {
          "description": "Lista planos de conta ativos do vendedor.",
          "rateLimit": "60 req/min"
        },
        "salesPaymentMethods": {
          "description": "Métodos ativos do vendedor + objeto gateway (provider, region, currency, mp_public_key, mp_credential_environment, payer_document, payer_document_rules). Use ?amount= para filtrar por valor do plano.",
          "rateLimit": "60 req/min"
        },
        "salesPayment": {
          "description": "Cria pagamento para compra de conta. payment_method_type: pix | credit_card | oxxo | rapipago | … (conforme região). Campos comuns: plan_id, gateway_id, customer_name, customer_email, customer_cpf (documento), identification_type (opcional).",
          "notes": "Cartão MP: card_token, mp_payment_method_id, installments, cardholder_name, mp_device_session_id (produção), mp_public_key_used; issuer_id opcional. Revenda pública exige reseller_username, reseller_email e reseller_password (mín. 6).",
          "rateLimit": "10 req/min"
        },
        "salesMessageTemplates": {
          "description": "Templates de mensagem pós-venda do vendedor.",
          "rateLimit": "60 req/min"
        }
      },
      "resellerSales": {
        "resellerPlans": {
          "description": "Lista planos de revenda do vendedor.",
          "rateLimit": "60 req/min"
        },
        "resellerPaymentMethods": {
          "description": "Mesmo formato de sales/payment-methods. Aceita ?amount=.",
          "rateLimit": "60 req/min"
        },
        "resellerPayment": {
          "description": "Cria pagamento para plano de revenda. Além dos campos de pagamento, envie reseller_username, reseller_email e reseller_password.",
          "notes": "customer_name/email/cpf referem-se ao pagador (titular do PIX/cartão), não às credenciais do painel de revenda.",
          "rateLimit": "10 req/min"
        },
        "resellerCheckUsername": {
          "description": "Verifica disponibilidade de username de revendedor.",
          "rateLimit": "30 req/min"
        },
        "resellerCheckEmail": {
          "description": "Verifica disponibilidade de e-mail de revendedor.",
          "rateLimit": "30 req/min"
        }
      },
      "renewal": {
        "renewalSearch": {
          "description": "Busca conta por username ou UUID V2Ray.",
          "rateLimit": "20 req/min"
        },
        "renewalPlans": {
          "description": "Planos disponíveis para renovação da conta encontrada.",
          "rateLimit": "60 req/min"
        },
        "renewalPaymentMethods": {
          "description": "Métodos do vendedor da conta. Query: seller_id (obrigatório), amount (opcional).",
          "rateLimit": "60 req/min"
        },
        "renewalPayment": {
          "description": "Renova conta encontrada em /renewal/search. Envie account_id, plan_id, gateway_id e dados do pagador.",
          "rateLimit": "10 req/min"
        }
      },
      "publicTest": {
        "testConfig": {
          "description": "Configuração da página de testes (duração, cooldown, V2Ray).",
          "rateLimit": "30 req/min"
        },
        "testCreate": {
          "description": "Gera conta de teste. Credenciais apenas por e-mail (nunca na resposta).",
          "rateLimit": "5 req/min"
        },
        "testCreateDirect": {
          "description": "Gera conta de teste e retorna credenciais no JSON. Somente X-Public-Api-Token do dono do slug. Cooldown por token.",
          "rateLimit": "5 req/min"
        }
      },
      "credentialRecovery": {
        "recoveryConfig": {
          "description": "Status da recuperação pública (habilitado, cooldown, SMTP).",
          "rateLimit": "30 req/min"
        },
        "recoveryRequest": {
          "description": "Reenvia todas as credenciais VPN vinculadas ao e-mail informado. Retorna erro 404 se não houver contas.",
          "rateLimit": "5 req/min"
        }
      },
      "payment": {
        "paymentStatus": {
          "description": "Consulta status pelo payment_id (ID Mercado Pago/Asaas) ou order_id. Se approved + account, retorna credenciais. provisioning:true = aprovado mas conta ainda sendo criada nos servidores.",
          "rateLimit": "60 req/min"
        },
        "paymentCancel": {
          "description": "Cancela pagamento com status pending (PIX, cartão ou cash ainda não pago).",
          "rateLimit": "20 req/min"
        }
      },
      "checkuser": {
        "dtunnel": {
          "description": "CheckUser DTunnel — validação de usuário e limite de devices.",
          "rateLimit": "60 req/min"
        },
        "conecta4g": {
          "description": "CheckUser Conecta4G — POST com credenciais do app.",
          "rateLimit": "60 req/min"
        }
      }
    },
    "downloadPostman": "Baixar collection Postman",
    "postmanDescription": "Collection Veltrix Panel. Variáveis: public_api_token, sales_slug, api_base_url. Exemplos de body usam PIX por padrão; veja a doc para cartão e cash."
  },
  "smtp": {
    "titleGlobal": "SMTP do painel",
    "titleUser": "SMTP da revenda",
    "enable": "Usar SMTP próprio",
    "helpGlobal": "SMTP padrão do painel. Revendedores podem configurar o deles em Automações.",
    "helpUser": "Opcional. Se desligado, os e-mails da sua revenda usam o SMTP do painel.",
    "host": "Host",
    "hostPlaceholder": "smtp.gmail.com",
    "port": "Porta",
    "encryption": "Criptografia",
    "encryptionNone": "Nenhuma",
    "username": "Usuario",
    "password": "Senha",
    "passwordKeep": "Deixe em branco para manter",
    "passwordPlaceholder": "Senha ou app password",
    "fromEmail": "E-mail remetente",
    "fromName": "Nome remetente",
    "testEmail": "E-mail de teste",
    "testEmailPlaceholder": "destino{'@'}exemplo.com",
    "testEmailHelp": "Opcional. Se vazio, usa o e-mail remetente. O teste usa os dados do formulário (não precisa salvar antes).",
    "usingGlobalFallback": "SMTP próprio desligado ou incompleto — e-mails saem pelo SMTP do painel.",
    "save": "Salvar SMTP",
    "testing": "Enviando...",
    "test": "Enviar e-mail de teste",
    "saved": "SMTP salvo",
    "saveError": "Erro ao salvar SMTP",
    "loadError": "Erro ao carregar SMTP",
    "testOk": "E-mail de teste enviado",
    "testFail": "Falha no envio de teste"
  },
  "publicApi": {
    "title": "Token de API pública",
    "help": "Um token por conta (admin ou revendedor). Use em servidor externo com header X-Public-Api-Token. Válido para rotas /api/public/* do seu slug. O PWA usa sessão por cookie — nunca embuta este token no frontend.",
    "activePrefix": "Token ativo:",
    "lastUsed": "Último uso: {date}",
    "copyNow": "Copie o token agora — ele não será exibido novamente.",
    "headerHint": "Envie em cada requisição: {header}: <seu_token>",
    "copyHeader": "Copiar header",
    "scopeHint": "Este token só funciona com o slug da sua conta: {slug}",
    "generate": "Gerar token",
    "regenerate": "Regenerar token",
    "revoke": "Revogar token",
    "regenerateConfirm": "Regenerar invalida o token atual. Continuar?",
    "revokeConfirm": "Revogar o token? Integrações externas deixarão de funcionar.",
    "loadError": "Erro ao carregar token",
    "generateError": "Erro ao gerar token",
    "revokeError": "Erro ao revogar token",
    "generated": "Token gerado",
    "revoked": "Token revogado"
  },
  "credentialRecovery": {
    "title": "Recuperar credenciais",
    "subtitle": "Informe o e-mail cadastrado na compra ou teste para receber suas credenciais VPN",
    "emailLabel": "E-mail",
    "emailPlaceholder": "seu{'@'}email.com",
    "help": "Enviaremos todas as contas vinculadas a este e-mail, com usuário, senha, status e validade. Cooldown de {cooldown}h por e-mail.",
    "submit": "Enviar credenciais por e-mail",
    "sending": "Enviando...",
    "successTitle": "Credenciais enviadas",
    "emailSentTo": "Enviamos as credenciais para {email}",
    "multipleAccountsSent": "{count} contas foram incluídas no mesmo e-mail.",
    "checkSpamHint": "Verifique a caixa de entrada e o spam.",
    "disabled": "Recuperação de credenciais está desativada no momento.",
    "smtpUnavailable": "Envio de e-mail indisponível. Configure o SMTP do painel.",
    "loadError": "Erro ao carregar página",
    "emailRequired": "E-mail é obrigatório",
    "notFound": "Nenhuma conta VPN encontrada para este e-mail.",
    "submitError": "Não foi possível processar a solicitação",
    "cooldownActive": "Aguarde {hours}h antes de solicitar novamente para este e-mail"
  }
}
